export const ROUTE_A = [
    {
        latitude: 48.154193,
        longitude: 11.616034,
    },
    {
        latitude: 48.15423,
        longitude: 11.616060000000001,
    },
    {
        latitude: 48.15457,
        longitude: 11.616290000000001,
    },
    {
        latitude: 48.15496,
        longitude: 11.616600000000002,
    },
    {
        latitude: 48.156400000000005,
        longitude: 11.617950000000002,
    },
    {
        latitude: 48.156940000000006,
        longitude: 11.618480000000002,
    },
    {
        latitude: 48.157430000000005,
        longitude: 11.618940000000002,
    },
    {
        latitude: 48.1578,
        longitude: 11.619260000000002,
    },
    {
        latitude: 48.158120000000004,
        longitude: 11.619540000000002,
    },
    {
        latitude: 48.15923,
        longitude: 11.620580000000002,
    },
    {
        latitude: 48.15937,
        longitude: 11.620710000000003,
    },
    {
        latitude: 48.159580000000005,
        longitude: 11.620910000000002,
    },
    {
        latitude: 48.159890000000004,
        longitude: 11.621190000000002,
    },
    {
        latitude: 48.16031,
        longitude: 11.621590000000003,
    },
    {
        latitude: 48.16044,
        longitude: 11.621710000000004,
    },
    {
        latitude: 48.16057,
        longitude: 11.621840000000004,
    },
    {
        latitude: 48.16069,
        longitude: 11.621950000000004,
    },
    {
        latitude: 48.16082,
        longitude: 11.622070000000004,
    },
    {
        latitude: 48.160920000000004,
        longitude: 11.622170000000004,
    },
    {
        latitude: 48.16274000000001,
        longitude: 11.623850000000004,
    },
    {
        latitude: 48.163320000000006,
        longitude: 11.624430000000004,
    },
    {
        latitude: 48.164550000000006,
        longitude: 11.625590000000004,
    },
    {
        latitude: 48.16675000000001,
        longitude: 11.627650000000004,
    },
    {
        latitude: 48.167350000000006,
        longitude: 11.628220000000004,
    },
    {
        latitude: 48.16774000000001,
        longitude: 11.628590000000004,
    },
    {
        latitude: 48.16983000000001,
        longitude: 11.630510000000005,
    },
    {
        latitude: 48.16990000000001,
        longitude: 11.630570000000004,
    },
    {
        latitude: 48.17007000000001,
        longitude: 11.630740000000005,
    },
    {
        latitude: 48.17013000000001,
        longitude: 11.630800000000004,
    },
    {
        latitude: 48.171980000000005,
        longitude: 11.632540000000004,
    },
    {
        latitude: 48.17228000000001,
        longitude: 11.632820000000004,
    },
    {
        latitude: 48.172880000000006,
        longitude: 11.633410000000005,
    },
    {
        latitude: 48.17344000000001,
        longitude: 11.634060000000005,
    },
    {
        latitude: 48.173860000000005,
        longitude: 11.634650000000006,
    },
    {
        latitude: 48.17416000000001,
        longitude: 11.635150000000007,
    },
    {
        latitude: 48.174420000000005,
        longitude: 11.635590000000006,
    },
    {
        latitude: 48.174600000000005,
        longitude: 11.635930000000005,
    },
    {
        latitude: 48.174670000000006,
        longitude: 11.636040000000005,
    },
    {
        latitude: 48.17481000000001,
        longitude: 11.636300000000006,
    },
    {
        latitude: 48.17499000000001,
        longitude: 11.636600000000005,
    },
    {
        latitude: 48.17522000000001,
        longitude: 11.636940000000005,
    },
    {
        latitude: 48.17552000000001,
        longitude: 11.637290000000004,
    },
    {
        latitude: 48.17560000000001,
        longitude: 11.637370000000004,
    },
    {
        latitude: 48.17574000000001,
        longitude: 11.637480000000004,
    },
    {
        latitude: 48.17596000000001,
        longitude: 11.637620000000004,
    },
    {
        latitude: 48.17604000000001,
        longitude: 11.637670000000004,
    },
    {
        latitude: 48.17634000000001,
        longitude: 11.637790000000004,
    },
    {
        latitude: 48.17657000000001,
        longitude: 11.637840000000004,
    },
    {
        latitude: 48.17673000000001,
        longitude: 11.637850000000004,
    },
    {
        latitude: 48.177050000000015,
        longitude: 11.637840000000004,
    },
    {
        latitude: 48.177270000000014,
        longitude: 11.637810000000004,
    },
    {
        latitude: 48.177430000000015,
        longitude: 11.637770000000003,
    },
    {
        latitude: 48.177590000000016,
        longitude: 11.637710000000004,
    },
    {
        latitude: 48.17778000000002,
        longitude: 11.637620000000004,
    },
    {
        latitude: 48.17805000000002,
        longitude: 11.637460000000004,
    },
    {
        latitude: 48.17819000000002,
        longitude: 11.637350000000005,
    },
    {
        latitude: 48.17839000000002,
        longitude: 11.637160000000005,
    },
    {
        latitude: 48.17867000000002,
        longitude: 11.636830000000005,
    },
    {
        latitude: 48.17917000000002,
        longitude: 11.636250000000006,
    },
    {
        latitude: 48.17931000000002,
        longitude: 11.636090000000006,
    },
    {
        latitude: 48.17947000000002,
        longitude: 11.635900000000007,
    },
    {
        latitude: 48.179920000000024,
        longitude: 11.635280000000007,
    },
    {
        latitude: 48.180210000000024,
        longitude: 11.634840000000008,
    },
    {
        latitude: 48.18034000000002,
        longitude: 11.634650000000008,
    },
    {
        latitude: 48.180680000000024,
        longitude: 11.634100000000007,
    },
    {
        latitude: 48.181200000000025,
        longitude: 11.633180000000007,
    },
    {
        latitude: 48.181400000000025,
        longitude: 11.632760000000006,
    },
    {
        latitude: 48.18155000000002,
        longitude: 11.632430000000006,
    },
    {
        latitude: 48.181760000000025,
        longitude: 11.631980000000006,
    },
    {
        latitude: 48.18188000000003,
        longitude: 11.631670000000005,
    },
    {
        latitude: 48.18199000000003,
        longitude: 11.631420000000006,
    },
    {
        latitude: 48.182210000000026,
        longitude: 11.630890000000006,
    },
    {
        latitude: 48.18235000000003,
        longitude: 11.630560000000006,
    },
    {
        latitude: 48.18248000000003,
        longitude: 11.630260000000007,
    },
    {
        latitude: 48.18258000000003,
        longitude: 11.630020000000007,
    },
    {
        latitude: 48.18273000000003,
        longitude: 11.629690000000007,
    },
    {
        latitude: 48.18313000000003,
        longitude: 11.628760000000007,
    },
    {
        latitude: 48.18332000000003,
        longitude: 11.628330000000007,
    },
    {
        latitude: 48.18343000000003,
        longitude: 11.628060000000007,
    },
    {
        latitude: 48.183710000000026,
        longitude: 11.627390000000007,
    },
    {
        latitude: 48.183930000000025,
        longitude: 11.626860000000008,
    },
    {
        latitude: 48.18408000000002,
        longitude: 11.626560000000008,
    },
    {
        latitude: 48.184180000000026,
        longitude: 11.626330000000008,
    },
    {
        latitude: 48.18435000000002,
        longitude: 11.625900000000009,
    },
    {
        latitude: 48.184850000000026,
        longitude: 11.624670000000009,
    },
    {
        latitude: 48.18526000000003,
        longitude: 11.62371000000001,
    },
    {
        latitude: 48.18537000000003,
        longitude: 11.623450000000009,
    },
    {
        latitude: 48.18564000000003,
        longitude: 11.62282000000001,
    },
    {
        latitude: 48.185680000000026,
        longitude: 11.62273000000001,
    },
    {
        latitude: 48.18585000000002,
        longitude: 11.622330000000009,
    },
    {
        latitude: 48.18605000000002,
        longitude: 11.621860000000009,
    },
    {
        latitude: 48.18620000000002,
        longitude: 11.621460000000008,
    },
    {
        latitude: 48.18632000000002,
        longitude: 11.621060000000007,
    },
    {
        latitude: 48.18643000000002,
        longitude: 11.620630000000007,
    },
    {
        latitude: 48.18654000000002,
        longitude: 11.620130000000007,
    },
    {
        latitude: 48.18660000000002,
        longitude: 11.619780000000008,
    },
    {
        latitude: 48.18663000000002,
        longitude: 11.619580000000008,
    },
    {
        latitude: 48.186680000000024,
        longitude: 11.619040000000007,
    },
    {
        latitude: 48.18672000000002,
        longitude: 11.618450000000006,
    },
    {
        latitude: 48.186750000000025,
        longitude: 11.618150000000007,
    },
    {
        latitude: 48.18672000000002,
        longitude: 11.617610000000006,
    },
    {
        latitude: 48.18665000000002,
        longitude: 11.616690000000006,
    },
    {
        latitude: 48.18662000000002,
        longitude: 11.616290000000005,
    },
    {
        latitude: 48.18660000000002,
        longitude: 11.616000000000005,
    },
    {
        latitude: 48.18657000000002,
        longitude: 11.615470000000006,
    },
    {
        latitude: 48.186560000000014,
        longitude: 11.615230000000006,
    },
    {
        latitude: 48.18658000000001,
        longitude: 11.614730000000005,
    },
    {
        latitude: 48.186650000000014,
        longitude: 11.614190000000004,
    },
    {
        latitude: 48.18668000000002,
        longitude: 11.614040000000005,
    },
    {
        latitude: 48.186740000000015,
        longitude: 11.613710000000005,
    },
    {
        latitude: 48.186790000000016,
        longitude: 11.613540000000004,
    },
    {
        latitude: 48.186810000000015,
        longitude: 11.613450000000004,
    },
    {
        latitude: 48.18689000000001,
        longitude: 11.613220000000004,
    },
    {
        latitude: 48.18695000000001,
        longitude: 11.613080000000004,
    },
    {
        latitude: 48.18709000000001,
        longitude: 11.612770000000003,
    },
    {
        latitude: 48.187190000000015,
        longitude: 11.612640000000003,
    },
    {
        latitude: 48.18731000000002,
        longitude: 11.612510000000002,
    },
    {
        latitude: 48.18743000000002,
        longitude: 11.612450000000003,
    },
    {
        latitude: 48.18758000000002,
        longitude: 11.612400000000003,
    },
    {
        latitude: 48.18769000000002,
        longitude: 11.612400000000003,
    },
    {
        latitude: 48.18788000000002,
        longitude: 11.612450000000003,
    },
    {
        latitude: 48.18821000000002,
        longitude: 11.612670000000003,
    },
    {
        latitude: 48.18884000000002,
        longitude: 11.613160000000002,
    },
    {
        latitude: 48.18927000000002,
        longitude: 11.613450000000002,
    },
    {
        latitude: 48.189480000000025,
        longitude: 11.613580000000002,
    },
    {
        latitude: 48.18960000000003,
        longitude: 11.613640000000002,
    },
    {
        latitude: 48.18976000000003,
        longitude: 11.613690000000002,
    },
    {
        latitude: 48.18995000000003,
        longitude: 11.613800000000001,
    },
    {
        latitude: 48.19031000000003,
        longitude: 11.614,
    },
    {
        latitude: 48.191010000000034,
        longitude: 11.614360000000001,
    },
    {
        latitude: 48.19198000000004,
        longitude: 11.614860000000002,
    },
    {
        latitude: 48.19396000000004,
        longitude: 11.615850000000002,
    },
    {
        latitude: 48.19609000000004,
        longitude: 11.616900000000001,
    },
    {
        latitude: 48.19679000000004,
        longitude: 11.61724,
    },
    {
        latitude: 48.19780000000004,
        longitude: 11.61772,
    },
    {
        latitude: 48.198210000000046,
        longitude: 11.61793,
    },
    {
        latitude: 48.198480000000046,
        longitude: 11.61805,
    },
    {
        latitude: 48.19867000000005,
        longitude: 11.61814,
    },
    {
        latitude: 48.19925000000005,
        longitude: 11.61841,
    },
    {
        latitude: 48.20010000000005,
        longitude: 11.61884,
    },
    {
        latitude: 48.20037000000005,
        longitude: 11.618970000000001,
    },
    {
        latitude: 48.20078000000005,
        longitude: 11.61918,
    },
    {
        latitude: 48.201660000000054,
        longitude: 11.61963,
    },
    {
        latitude: 48.20204000000005,
        longitude: 11.61982,
    },
    {
        latitude: 48.20243000000006,
        longitude: 11.62002,
    },
    {
        latitude: 48.202560000000055,
        longitude: 11.62008,
    },
    {
        latitude: 48.20300000000005,
        longitude: 11.6203,
    },
    {
        latitude: 48.20421000000005,
        longitude: 11.62091,
    },
    {
        latitude: 48.205160000000056,
        longitude: 11.62138,
    },
    {
        latitude: 48.20645000000005,
        longitude: 11.62205,
    },
    {
        latitude: 48.207040000000056,
        longitude: 11.62234,
    },
    {
        latitude: 48.20808000000006,
        longitude: 11.62286,
    },
    {
        latitude: 48.21016000000006,
        longitude: 11.62392,
    },
    {
        latitude: 48.21095000000006,
        longitude: 11.62431,
    },
    {
        latitude: 48.21189000000006,
        longitude: 11.624799999999999,
    },
    {
        latitude: 48.21303000000006,
        longitude: 11.625379999999998,
    },
    {
        latitude: 48.21346000000006,
        longitude: 11.625599999999999,
    },
    {
        latitude: 48.21665000000006,
        longitude: 11.62718,
    },
    {
        latitude: 48.21810000000006,
        longitude: 11.627889999999999,
    },
    {
        latitude: 48.21884000000006,
        longitude: 11.628269999999999,
    },
    {
        latitude: 48.21956000000006,
        longitude: 11.628619999999998,
    },
    {
        latitude: 48.220450000000056,
        longitude: 11.629079999999998,
    },
    {
        latitude: 48.220940000000056,
        longitude: 11.629319999999998,
    },
    {
        latitude: 48.221140000000055,
        longitude: 11.629429999999997,
    },
    {
        latitude: 48.22173000000006,
        longitude: 11.629709999999998,
    },
    {
        latitude: 48.222890000000056,
        longitude: 11.630299999999998,
    },
    {
        latitude: 48.22500000000006,
        longitude: 11.631359999999999,
    },
    {
        latitude: 48.22561000000006,
        longitude: 11.631659999999998,
    },
    {
        latitude: 48.22699000000006,
        longitude: 11.632349999999999,
    },
    {
        latitude: 48.227270000000054,
        longitude: 11.632489999999999,
    },
    {
        latitude: 48.22740000000005,
        longitude: 11.632549999999998,
    },
    {
        latitude: 48.22825000000005,
        longitude: 11.632989999999998,
    },
    {
        latitude: 48.228680000000054,
        longitude: 11.633209999999998,
    },
    {
        latitude: 48.22993000000005,
        longitude: 11.633849999999999,
    },
    {
        latitude: 48.230320000000056,
        longitude: 11.634049999999998,
    },
    {
        latitude: 48.23085000000005,
        longitude: 11.63431,
    },
    {
        latitude: 48.23143000000005,
        longitude: 11.634609999999999,
    },
    {
        latitude: 48.231750000000055,
        longitude: 11.634769999999998,
    },
    {
        latitude: 48.23189000000006,
        longitude: 11.634839999999997,
    },
    {
        latitude: 48.23196000000006,
        longitude: 11.634869999999998,
    },
    {
        latitude: 48.23315000000006,
        longitude: 11.635459999999998,
    },
    {
        latitude: 48.23329000000006,
        longitude: 11.635529999999997,
    },
    {
        latitude: 48.23616000000006,
        longitude: 11.636959999999997,
    },
    {
        latitude: 48.237150000000064,
        longitude: 11.637449999999996,
    },
    {
        latitude: 48.23764000000006,
        longitude: 11.637699999999995,
    },
    {
        latitude: 48.238590000000066,
        longitude: 11.638179999999995,
    },
    {
        latitude: 48.238810000000065,
        longitude: 11.638289999999994,
    },
    {
        latitude: 48.239100000000064,
        longitude: 11.638439999999994,
    },
    {
        latitude: 48.240150000000064,
        longitude: 11.638969999999993,
    },
    {
        latitude: 48.24046000000006,
        longitude: 11.639269999999993,
    },
    {
        latitude: 48.24063000000006,
        longitude: 11.639479999999992,
    },
    {
        latitude: 48.24074000000006,
        longitude: 11.639649999999993,
    },
    {
        latitude: 48.24083000000006,
        longitude: 11.639849999999992,
    },
    {
        latitude: 48.24090000000006,
        longitude: 11.640069999999993,
    },
    {
        latitude: 48.24094000000006,
        longitude: 11.640239999999993,
    },
    {
        latitude: 48.24100000000006,
        longitude: 11.640579999999993,
    },
    {
        latitude: 48.24105000000006,
        longitude: 11.640739999999992,
    },
    {
        latitude: 48.24117000000006,
        longitude: 11.641009999999993,
    },
    {
        latitude: 48.241470000000064,
        longitude: 11.641549999999993,
    },
    {
        latitude: 48.24158000000006,
        longitude: 11.641759999999993,
    },
    {
        latitude: 48.241790000000066,
        longitude: 11.642199999999992,
    },
    {
        latitude: 48.24153000000007,
        longitude: 11.642559999999992,
    },
    {
        latitude: 48.24136000000007,
        longitude: 11.642819999999993,
    },
    {
        latitude: 48.24129000000007,
        longitude: 11.642989999999994,
    },
    {
        latitude: 48.24098000000007,
        longitude: 11.643479999999993,
    },
    {
        latitude: 48.24088000000007,
        longitude: 11.643559999999994,
    },
    {
        latitude: 48.24077000000007,
        longitude: 11.643769999999993,
    },
    {
        latitude: 48.24057000000007,
        longitude: 11.644149999999993,
    },
    {
        latitude: 48.240650000000066,
        longitude: 11.644209999999992,
    },
    {
        latitude: 48.24090000000007,
        longitude: 11.644409999999992,
    },
    {
        latitude: 48.241410000000066,
        longitude: 11.644769999999992,
    },
    {
        latitude: 48.241830000000064,
        longitude: 11.645059999999992,
    },
    {
        latitude: 48.24200000000006,
        longitude: 11.645169999999991,
    },
    {
        latitude: 48.24226000000006,
        longitude: 11.645339999999992,
    },
    {
        latitude: 48.24267000000006,
        longitude: 11.645619999999992,
    },
    {
        latitude: 48.24290000000006,
        longitude: 11.645779999999991,
    },
    {
        latitude: 48.243130000000065,
        longitude: 11.645949999999992,
    },
    {
        latitude: 48.24336000000007,
        longitude: 11.646109999999991,
    },
    {
        latitude: 48.24408000000007,
        longitude: 11.64659999999999,
    },
    {
        latitude: 48.244410000000066,
        longitude: 11.64682999999999,
    },
    {
        latitude: 48.244540000000065,
        longitude: 11.64691999999999,
    },
    {
        latitude: 48.24466000000007,
        longitude: 11.646999999999991,
    },
    {
        latitude: 48.244920000000064,
        longitude: 11.647179999999992,
    },
    {
        latitude: 48.24500000000006,
        longitude: 11.647239999999991,
    },
    {
        latitude: 48.24505000000006,
        longitude: 11.647279999999991,
    },
    {
        latitude: 48.245370000000065,
        longitude: 11.647499999999992,
    },
    {
        latitude: 48.24556000000007,
        longitude: 11.647649999999992,
    },
    {
        latitude: 48.24595000000007,
        longitude: 11.647989999999991,
    },
    {
        latitude: 48.24609000000007,
        longitude: 11.64813999999999,
    },
    {
        latitude: 48.246340000000075,
        longitude: 11.64848999999999,
    },
    {
        latitude: 48.24665000000007,
        longitude: 11.64894999999999,
    },
    {
        latitude: 48.24702000000007,
        longitude: 11.649489999999991,
    },
    {
        latitude: 48.24730000000007,
        longitude: 11.649909999999991,
    },
    {
        latitude: 48.24739000000007,
        longitude: 11.650059999999991,
    },
    {
        latitude: 48.24749000000007,
        longitude: 11.65021999999999,
    },
    {
        latitude: 48.24754000000007,
        longitude: 11.65027999999999,
    },
    {
        latitude: 48.24770000000007,
        longitude: 11.650489999999989,
    },
    {
        latitude: 48.247930000000075,
        longitude: 11.65074999999999,
    },
    {
        latitude: 48.248130000000074,
        longitude: 11.65091999999999,
    },
    {
        latitude: 48.248380000000076,
        longitude: 11.65106999999999,
    },
    {
        latitude: 48.24864000000007,
        longitude: 11.65118999999999,
    },
    {
        latitude: 48.248830000000076,
        longitude: 11.65125999999999,
    },
    {
        latitude: 48.24891000000007,
        longitude: 11.65130999999999,
    },
    {
        latitude: 48.249030000000076,
        longitude: 11.65144999999999,
    },
    {
        latitude: 48.24909000000007,
        longitude: 11.65154999999999,
    },
    {
        latitude: 48.249210000000076,
        longitude: 11.65182999999999,
    },
    {
        latitude: 48.24900000000007,
        longitude: 11.65207999999999,
    },
    {
        latitude: 48.24890000000007,
        longitude: 11.652269999999989,
    },
    {
        latitude: 48.24884000000007,
        longitude: 11.65253999999999,
    },
    {
        latitude: 48.24882000000007,
        longitude: 11.65267999999999,
    },
    {
        latitude: 48.248740000000076,
        longitude: 11.65318999999999,
    },
    {
        latitude: 48.24868000000008,
        longitude: 11.65344999999999,
    },
    {
        latitude: 48.24851000000008,
        longitude: 11.65396999999999,
    },
    {
        latitude: 48.24841000000008,
        longitude: 11.65426999999999,
    },
    {
        latitude: 48.24853000000008,
        longitude: 11.65446999999999,
    },
    {
        latitude: 48.248540000000084,
        longitude: 11.65455999999999,
    },
    {
        latitude: 48.24847000000008,
        longitude: 11.65496999999999,
    },
    {
        latitude: 48.24831000000008,
        longitude: 11.65491999999999,
    },
    {
        latitude: 48.248140000000085,
        longitude: 11.65480999999999,
    },
    {
        latitude: 48.248210000000086,
        longitude: 11.65472999999999,
    },
    {
        latitude: 48.24826000000009,
        longitude: 11.65464999999999,
    },
    {
        latitude: 48.248410000000085,
        longitude: 11.65426999999999,
    },
    {
        latitude: 48.24851000000009,
        longitude: 11.65396999999999,
    },
    {
        latitude: 48.248680000000085,
        longitude: 11.65344999999999,
    },
    {
        latitude: 48.24874000000008,
        longitude: 11.65318999999999,
    },
    {
        latitude: 48.249010000000084,
        longitude: 11.653159999999989,
    },
    {
        latitude: 48.24907900000009,
        longitude: 11.653157999999989,
    },
] as const;

export const ROUTE_B = [
    {
        latitude: 48.213,
        longitude: 11.46752,
    },
    {
        latitude: 48.21288,
        longitude: 11.46761,
    },
    {
        latitude: 48.21262,
        longitude: 11.467550000000001,
    },
    {
        latitude: 48.21228,
        longitude: 11.46751,
    },
    {
        latitude: 48.21174,
        longitude: 11.46748,
    },
    {
        latitude: 48.21133,
        longitude: 11.46744,
    },
    {
        latitude: 48.210879999999996,
        longitude: 11.46742,
    },
    {
        latitude: 48.210629999999995,
        longitude: 11.46742,
    },
    {
        latitude: 48.210179999999994,
        longitude: 11.46748,
    },
    {
        latitude: 48.210089999999994,
        longitude: 11.4675,
    },
    {
        latitude: 48.210029999999996,
        longitude: 11.467519999999999,
    },
    {
        latitude: 48.209909999999994,
        longitude: 11.467569999999998,
    },
    {
        latitude: 48.20996999999999,
        longitude: 11.468549999999999,
    },
    {
        latitude: 48.20998999999999,
        longitude: 11.471079999999999,
    },
    {
        latitude: 48.20998999999999,
        longitude: 11.473329999999999,
    },
    {
        latitude: 48.209999999999994,
        longitude: 11.473939999999999,
    },
    {
        latitude: 48.209999999999994,
        longitude: 11.474549999999999,
    },
    {
        latitude: 48.21001,
        longitude: 11.476539999999998,
    },
    {
        latitude: 48.209999999999994,
        longitude: 11.477539999999998,
    },
    {
        latitude: 48.20994999999999,
        longitude: 11.478649999999998,
    },
    {
        latitude: 48.20985999999999,
        longitude: 11.479649999999998,
    },
    {
        latitude: 48.20973999999999,
        longitude: 11.480599999999997,
    },
    {
        latitude: 48.20970999999999,
        longitude: 11.480889999999997,
    },
    {
        latitude: 48.20962999999999,
        longitude: 11.481859999999998,
    },
    {
        latitude: 48.20960999999999,
        longitude: 11.482449999999998,
    },
    {
        latitude: 48.20960999999999,
        longitude: 11.482569999999999,
    },
    {
        latitude: 48.20963999999999,
        longitude: 11.48283,
    },
    {
        latitude: 48.20965999999999,
        longitude: 11.482899999999999,
    },
    {
        latitude: 48.20971999999999,
        longitude: 11.48307,
    },
    {
        latitude: 48.20995999999999,
        longitude: 11.48363,
    },
    {
        latitude: 48.21009999999999,
        longitude: 11.48404,
    },
    {
        latitude: 48.21017999999999,
        longitude: 11.484440000000001,
    },
    {
        latitude: 48.210219999999985,
        longitude: 11.48474,
    },
    {
        latitude: 48.210239999999985,
        longitude: 11.48506,
    },
    {
        latitude: 48.20977999999999,
        longitude: 11.48513,
    },
    {
        latitude: 48.20940999999999,
        longitude: 11.48522,
    },
    {
        latitude: 48.20901999999999,
        longitude: 11.48532,
    },
    {
        latitude: 48.208829999999985,
        longitude: 11.4854,
    },
    {
        latitude: 48.20852999999998,
        longitude: 11.48554,
    },
    {
        latitude: 48.20814999999998,
        longitude: 11.48575,
    },
    {
        latitude: 48.20801999999998,
        longitude: 11.48583,
    },
    {
        latitude: 48.20744999999998,
        longitude: 11.48623,
    },
    {
        latitude: 48.20713999999998,
        longitude: 11.48647,
    },
    {
        latitude: 48.20639999999998,
        longitude: 11.4871,
    },
    {
        latitude: 48.20294999999998,
        longitude: 11.49012,
    },
    {
        latitude: 48.20209999999998,
        longitude: 11.49085,
    },
    {
        latitude: 48.20144999999998,
        longitude: 11.49138,
    },
    {
        latitude: 48.20105999999998,
        longitude: 11.491719999999999,
    },
    {
        latitude: 48.20052999999998,
        longitude: 11.492209999999998,
    },
    {
        latitude: 48.19990999999998,
        longitude: 11.492829999999998,
    },
    {
        latitude: 48.19930999999998,
        longitude: 11.493499999999997,
    },
    {
        latitude: 48.198909999999984,
        longitude: 11.493899999999998,
    },
    {
        latitude: 48.19878999999998,
        longitude: 11.494019999999999,
    },
    {
        latitude: 48.19864999999998,
        longitude: 11.494119999999999,
    },
    {
        latitude: 48.19839999999998,
        longitude: 11.494279999999998,
    },
    {
        latitude: 48.198079999999976,
        longitude: 11.494459999999998,
    },
    {
        latitude: 48.19772999999998,
        longitude: 11.494599999999998,
    },
    {
        latitude: 48.19741999999998,
        longitude: 11.494659999999998,
    },
    {
        latitude: 48.19652999999998,
        longitude: 11.494709999999998,
    },
    {
        latitude: 48.19629999999998,
        longitude: 11.494709999999998,
    },
    {
        latitude: 48.19591999999998,
        longitude: 11.494729999999997,
    },
    {
        latitude: 48.19575999999998,
        longitude: 11.494749999999996,
    },
    {
        latitude: 48.19549999999998,
        longitude: 11.494809999999996,
    },
    {
        latitude: 48.19522999999998,
        longitude: 11.494889999999996,
    },
    {
        latitude: 48.19497999999998,
        longitude: 11.495009999999997,
    },
    {
        latitude: 48.19476999999998,
        longitude: 11.495149999999997,
    },
    {
        latitude: 48.194629999999975,
        longitude: 11.495269999999998,
    },
    {
        latitude: 48.194319999999976,
        longitude: 11.495619999999997,
    },
    {
        latitude: 48.194229999999976,
        longitude: 11.495749999999997,
    },
    {
        latitude: 48.194199999999974,
        longitude: 11.495809999999997,
    },
    {
        latitude: 48.19401999999997,
        longitude: 11.496149999999997,
    },
    {
        latitude: 48.193889999999975,
        longitude: 11.496429999999997,
    },
    {
        latitude: 48.19378999999997,
        longitude: 11.496719999999996,
    },
    {
        latitude: 48.19362999999997,
        longitude: 11.497429999999996,
    },
    {
        latitude: 48.19349999999997,
        longitude: 11.498129999999996,
    },
    {
        latitude: 48.193129999999975,
        longitude: 11.500339999999996,
    },
    {
        latitude: 48.19293999999997,
        longitude: 11.501539999999997,
    },
    {
        latitude: 48.19288999999997,
        longitude: 11.502039999999997,
    },
    {
        latitude: 48.19279999999997,
        longitude: 11.502039999999997,
    },
    {
        latitude: 48.19269999999997,
        longitude: 11.502049999999997,
    },
    {
        latitude: 48.192399999999964,
        longitude: 11.502019999999996,
    },
    {
        latitude: 48.192289999999964,
        longitude: 11.502019999999996,
    },
    {
        latitude: 48.19209999999996,
        longitude: 11.502059999999997,
    },
    {
        latitude: 48.19195999999996,
        longitude: 11.502099999999997,
    },
    {
        latitude: 48.19181999999996,
        longitude: 11.502169999999996,
    },
    {
        latitude: 48.19121999999996,
        longitude: 11.502419999999995,
    },
    {
        latitude: 48.19089999999996,
        longitude: 11.502539999999996,
    },
    {
        latitude: 48.19074999999996,
        longitude: 11.502599999999996,
    },
    {
        latitude: 48.19047999999996,
        longitude: 11.502689999999996,
    },
    {
        latitude: 48.19031999999996,
        longitude: 11.502729999999996,
    },
    {
        latitude: 48.190069999999956,
        longitude: 11.502809999999997,
    },
    {
        latitude: 48.18953999999996,
        longitude: 11.502979999999997,
    },
    {
        latitude: 48.18948999999996,
        longitude: 11.502999999999997,
    },
    {
        latitude: 48.18913999999996,
        longitude: 11.503109999999996,
    },
    {
        latitude: 48.18893999999996,
        longitude: 11.503169999999995,
    },
    {
        latitude: 48.18878999999996,
        longitude: 11.503219999999995,
    },
    {
        latitude: 48.18867999999996,
        longitude: 11.503249999999996,
    },
    {
        latitude: 48.18853999999996,
        longitude: 11.503289999999996,
    },
    {
        latitude: 48.188169999999964,
        longitude: 11.503409999999997,
    },
    {
        latitude: 48.18800999999996,
        longitude: 11.503449999999997,
    },
    {
        latitude: 48.18791999999996,
        longitude: 11.503479999999998,
    },
    {
        latitude: 48.187639999999966,
        longitude: 11.503569999999998,
    },
    {
        latitude: 48.18708999999997,
        longitude: 11.503759999999998,
    },
    {
        latitude: 48.18637999999997,
        longitude: 11.503989999999998,
    },
    {
        latitude: 48.186029999999974,
        longitude: 11.504119999999999,
    },
    {
        latitude: 48.18579999999997,
        longitude: 11.504219999999998,
    },
    {
        latitude: 48.18552999999997,
        longitude: 11.504369999999998,
    },
    {
        latitude: 48.18538999999997,
        longitude: 11.504489999999999,
    },
    {
        latitude: 48.18526999999997,
        longitude: 11.504629999999999,
    },
    {
        latitude: 48.18497999999997,
        longitude: 11.505019999999998,
    },
    {
        latitude: 48.18471999999997,
        longitude: 11.505389999999998,
    },
    {
        latitude: 48.18464999999997,
        longitude: 11.505489999999998,
    },
    {
        latitude: 48.18457999999997,
        longitude: 11.505579999999998,
    },
    {
        latitude: 48.184389999999965,
        longitude: 11.505829999999998,
    },
    {
        latitude: 48.183739999999965,
        longitude: 11.506789999999997,
    },
    {
        latitude: 48.18361999999996,
        longitude: 11.506959999999998,
    },
    {
        latitude: 48.18352999999996,
        longitude: 11.507099999999998,
    },
    {
        latitude: 48.18341999999996,
        longitude: 11.507319999999998,
    },
    {
        latitude: 48.183289999999964,
        longitude: 11.507639999999999,
    },
    {
        latitude: 48.183199999999964,
        longitude: 11.507819999999999,
    },
    {
        latitude: 48.18318999999996,
        longitude: 11.50785,
    },
    {
        latitude: 48.18311999999996,
        longitude: 11.508,
    },
    {
        latitude: 48.18285999999996,
        longitude: 11.5077,
    },
    {
        latitude: 48.182619999999964,
        longitude: 11.507439999999999,
    },
    {
        latitude: 48.18246999999997,
        longitude: 11.507259999999999,
    },
    {
        latitude: 48.18224999999997,
        longitude: 11.507029999999999,
    },
    {
        latitude: 48.181819999999966,
        longitude: 11.50654,
    },
    {
        latitude: 48.181659999999965,
        longitude: 11.50633,
    },
    {
        latitude: 48.18142999999996,
        longitude: 11.50595,
    },
    {
        latitude: 48.181259999999966,
        longitude: 11.505650000000001,
    },
    {
        latitude: 48.18119999999997,
        longitude: 11.505550000000001,
    },
    {
        latitude: 48.18111999999997,
        longitude: 11.505360000000001,
    },
    {
        latitude: 48.18095999999997,
        longitude: 11.504840000000002,
    },
    {
        latitude: 48.18091999999997,
        longitude: 11.50467,
    },
    {
        latitude: 48.18087999999997,
        longitude: 11.504480000000001,
    },
    {
        latitude: 48.18082999999997,
        longitude: 11.504180000000002,
    },
    {
        latitude: 48.18079999999997,
        longitude: 11.503900000000002,
    },
    {
        latitude: 48.18074999999997,
        longitude: 11.503220000000002,
    },
    {
        latitude: 48.18072999999997,
        longitude: 11.502980000000003,
    },
    {
        latitude: 48.18067999999997,
        longitude: 11.502500000000003,
    },
    {
        latitude: 48.180609999999966,
        longitude: 11.501980000000003,
    },
    {
        latitude: 48.18050999999996,
        longitude: 11.501490000000004,
    },
    {
        latitude: 48.180429999999966,
        longitude: 11.501080000000004,
    },
    {
        latitude: 48.180319999999966,
        longitude: 11.500660000000003,
    },
    {
        latitude: 48.18007999999997,
        longitude: 11.499660000000004,
    },
    {
        latitude: 48.17981999999997,
        longitude: 11.498720000000004,
    },
    {
        latitude: 48.17971999999997,
        longitude: 11.498360000000003,
    },
    {
        latitude: 48.17956999999997,
        longitude: 11.497810000000003,
    },
    {
        latitude: 48.17950999999997,
        longitude: 11.497610000000003,
    },
    {
        latitude: 48.17945999999997,
        longitude: 11.497410000000004,
    },
    {
        latitude: 48.17934999999997,
        longitude: 11.497020000000004,
    },
    {
        latitude: 48.17920999999997,
        longitude: 11.496290000000004,
    },
    {
        latitude: 48.17917999999997,
        longitude: 11.496140000000004,
    },
    {
        latitude: 48.17909999999997,
        longitude: 11.495890000000005,
    },
    {
        latitude: 48.17901999999997,
        longitude: 11.495710000000004,
    },
    {
        latitude: 48.17882999999997,
        longitude: 11.495420000000005,
    },
    {
        latitude: 48.17865999999997,
        longitude: 11.495250000000004,
    },
    {
        latitude: 48.17834999999997,
        longitude: 11.495030000000003,
    },
    {
        latitude: 48.17807999999997,
        longitude: 11.494830000000004,
    },
    {
        latitude: 48.17798999999997,
        longitude: 11.494760000000005,
    },
    {
        latitude: 48.17779999999997,
        longitude: 11.495210000000005,
    },
    {
        latitude: 48.17774999999997,
        longitude: 11.495380000000006,
    },
    {
        latitude: 48.17756999999997,
        longitude: 11.495760000000006,
    },
    {
        latitude: 48.17734999999997,
        longitude: 11.496220000000006,
    },
    {
        latitude: 48.17721999999997,
        longitude: 11.496490000000007,
    },
    {
        latitude: 48.17700999999997,
        longitude: 11.496920000000006,
    },
    {
        latitude: 48.176999999999964,
        longitude: 11.496950000000007,
    },
    {
        latitude: 48.176979999999965,
        longitude: 11.496990000000007,
    },
    {
        latitude: 48.17669999999997,
        longitude: 11.497580000000008,
    },
    {
        latitude: 48.17571999999997,
        longitude: 11.499600000000008,
    },
    {
        latitude: 48.17537999999997,
        longitude: 11.500310000000008,
    },
    {
        latitude: 48.17494999999997,
        longitude: 11.501170000000007,
    },
    {
        latitude: 48.17467999999997,
        longitude: 11.501710000000008,
    },
    {
        latitude: 48.17448999999996,
        longitude: 11.502050000000008,
    },
    {
        latitude: 48.174179999999964,
        longitude: 11.502540000000007,
    },
    {
        latitude: 48.174049999999966,
        longitude: 11.502700000000006,
    },
    {
        latitude: 48.17345999999996,
        longitude: 11.503500000000006,
    },
    {
        latitude: 48.172999999999966,
        longitude: 11.504160000000006,
    },
    {
        latitude: 48.17275999999997,
        longitude: 11.504480000000006,
    },
    {
        latitude: 48.172529999999966,
        longitude: 11.504820000000006,
    },
    {
        latitude: 48.172369999999965,
        longitude: 11.505090000000006,
    },
    {
        latitude: 48.172099999999965,
        longitude: 11.505640000000007,
    },
    {
        latitude: 48.171879999999966,
        longitude: 11.506140000000007,
    },
    {
        latitude: 48.17177999999996,
        longitude: 11.506370000000008,
    },
    {
        latitude: 48.17168999999996,
        longitude: 11.506580000000007,
    },
    {
        latitude: 48.17139999999996,
        longitude: 11.507250000000006,
    },
    {
        latitude: 48.17127999999996,
        longitude: 11.507530000000006,
    },
    {
        latitude: 48.17116999999996,
        longitude: 11.507770000000006,
    },
    {
        latitude: 48.17094999999996,
        longitude: 11.508280000000006,
    },
    {
        latitude: 48.17089999999996,
        longitude: 11.508380000000006,
    },
    {
        latitude: 48.17075999999996,
        longitude: 11.508710000000006,
    },
    {
        latitude: 48.17050999999996,
        longitude: 11.509380000000005,
    },
    {
        latitude: 48.17041999999996,
        longitude: 11.509530000000005,
    },
    {
        latitude: 48.17013999999996,
        longitude: 11.510170000000006,
    },
    {
        latitude: 48.16992999999996,
        longitude: 11.510550000000006,
    },
    {
        latitude: 48.169609999999956,
        longitude: 11.510510000000005,
    },
    {
        latitude: 48.169469999999954,
        longitude: 11.510470000000005,
    },
    {
        latitude: 48.169319999999956,
        longitude: 11.510420000000005,
    },
    {
        latitude: 48.16833999999996,
        longitude: 11.510020000000004,
    },
    {
        latitude: 48.16802999999996,
        longitude: 11.509880000000004,
    },
    {
        latitude: 48.16789999999996,
        longitude: 11.509820000000005,
    },
    {
        latitude: 48.16749999999996,
        longitude: 11.509590000000005,
    },
    {
        latitude: 48.167149999999964,
        longitude: 11.509390000000005,
    },
    {
        latitude: 48.166859999999964,
        longitude: 11.509200000000005,
    },
    {
        latitude: 48.16604999999996,
        longitude: 11.508610000000004,
    },
    {
        latitude: 48.16579999999996,
        longitude: 11.508420000000005,
    },
    {
        latitude: 48.16567999999996,
        longitude: 11.508330000000004,
    },
    {
        latitude: 48.16507999999996,
        longitude: 11.507890000000005,
    },
    {
        latitude: 48.16477999999996,
        longitude: 11.507670000000005,
    },
    {
        latitude: 48.164189999999955,
        longitude: 11.507230000000005,
    },
    {
        latitude: 48.16392999999996,
        longitude: 11.507040000000005,
    },
    {
        latitude: 48.16383999999996,
        longitude: 11.506980000000006,
    },
    {
        latitude: 48.16377999999996,
        longitude: 11.506950000000005,
    },
    {
        latitude: 48.16368999999996,
        longitude: 11.506900000000005,
    },
    {
        latitude: 48.16314999999996,
        longitude: 11.508160000000005,
    },
    {
        latitude: 48.16253999999996,
        longitude: 11.509410000000006,
    },
    {
        latitude: 48.162239999999954,
        longitude: 11.509950000000007,
    },
    {
        latitude: 48.16213999999995,
        longitude: 11.510120000000008,
    },
    {
        latitude: 48.16177999999995,
        longitude: 11.510710000000008,
    },
    {
        latitude: 48.16155999999995,
        longitude: 11.511040000000008,
    },
    {
        latitude: 48.16145999999995,
        longitude: 11.511130000000009,
    },
    {
        latitude: 48.16136999999995,
        longitude: 11.511180000000008,
    },
    {
        latitude: 48.161269999999945,
        longitude: 11.511230000000008,
    },
    {
        latitude: 48.16107999999994,
        longitude: 11.511270000000009,
    },
    {
        latitude: 48.16059999999994,
        longitude: 11.511310000000009,
    },
    {
        latitude: 48.160389999999936,
        longitude: 11.511310000000009,
    },
    {
        latitude: 48.159759999999935,
        longitude: 11.511330000000008,
    },
    {
        latitude: 48.15945999999993,
        longitude: 11.511330000000008,
    },
    {
        latitude: 48.158749999999934,
        longitude: 11.511330000000008,
    },
    {
        latitude: 48.15856999999993,
        longitude: 11.511340000000008,
    },
    {
        latitude: 48.158309999999936,
        longitude: 11.511350000000007,
    },
    {
        latitude: 48.15802999999994,
        longitude: 11.511350000000007,
    },
    {
        latitude: 48.15780999999994,
        longitude: 11.511360000000007,
    },
    {
        latitude: 48.15722999999994,
        longitude: 11.511400000000007,
    },
    {
        latitude: 48.15709999999994,
        longitude: 11.511420000000006,
    },
    {
        latitude: 48.15648999999994,
        longitude: 11.511480000000006,
    },
    {
        latitude: 48.15621999999994,
        longitude: 11.511500000000005,
    },
    {
        latitude: 48.156139999999944,
        longitude: 11.511480000000006,
    },
    {
        latitude: 48.15599999999994,
        longitude: 11.511390000000006,
    },
    {
        latitude: 48.155829999999945,
        longitude: 11.511220000000005,
    },
    {
        latitude: 48.155699999999946,
        longitude: 11.511170000000005,
    },
    {
        latitude: 48.15558999999995,
        longitude: 11.511220000000005,
    },
    {
        latitude: 48.15545999999995,
        longitude: 11.511220000000005,
    },
    {
        latitude: 48.15471999999995,
        longitude: 11.511240000000004,
    },
    {
        latitude: 48.154619999999944,
        longitude: 11.511250000000004,
    },
    {
        latitude: 48.15445999999994,
        longitude: 11.511300000000004,
    },
    {
        latitude: 48.15447999999994,
        longitude: 11.510810000000005,
    },
    {
        latitude: 48.15449999999994,
        longitude: 11.510400000000004,
    },
    {
        latitude: 48.15447999999994,
        longitude: 11.510070000000004,
    },
    {
        latitude: 48.15442999999994,
        longitude: 11.509870000000005,
    },
    {
        latitude: 48.15436999999994,
        longitude: 11.509730000000005,
    },
    {
        latitude: 48.154289999999946,
        longitude: 11.509620000000005,
    },
    {
        latitude: 48.154039999999945,
        longitude: 11.509380000000005,
    },
    {
        latitude: 48.15390999999995,
        longitude: 11.509260000000005,
    },
    {
        latitude: 48.15379999999995,
        longitude: 11.509170000000005,
    },
    {
        latitude: 48.153499999999944,
        longitude: 11.508910000000004,
    },
    {
        latitude: 48.153169999999946,
        longitude: 11.508610000000004,
    },
    {
        latitude: 48.153009999999945,
        longitude: 11.508330000000004,
    },
    {
        latitude: 48.15288999999994,
        longitude: 11.508080000000005,
    },
    {
        latitude: 48.15277999999994,
        longitude: 11.507830000000006,
    },
    {
        latitude: 48.152699999999946,
        longitude: 11.507600000000005,
    },
    {
        latitude: 48.15265999999995,
        longitude: 11.507440000000006,
    },
    {
        latitude: 48.15258999999995,
        longitude: 11.507210000000006,
    },
    {
        latitude: 48.15251599999995,
        longitude: 11.506938000000005,
    },
] as const;

export const ROUTE_C = [
    {
        latitude: 48.136275,
        longitude: 11.579424,
    },
    {
        latitude: 48.136179999999996,
        longitude: 11.57927,
    },
    {
        latitude: 48.13612,
        longitude: 11.57921,
    },
    {
        latitude: 48.13605,
        longitude: 11.57917,
    },
    {
        latitude: 48.135979999999996,
        longitude: 11.57949,
    },
    {
        latitude: 48.1359,
        longitude: 11.57982,
    },
    {
        latitude: 48.13587,
        longitude: 11.57993,
    },
    {
        latitude: 48.13567,
        longitude: 11.58052,
    },
    {
        latitude: 48.13541,
        longitude: 11.5813,
    },
    {
        latitude: 48.13525,
        longitude: 11.581430000000001,
    },
    {
        latitude: 48.13519,
        longitude: 11.581460000000002,
    },
    {
        latitude: 48.13508,
        longitude: 11.58148,
    },
    {
        latitude: 48.1349,
        longitude: 11.58154,
    },
    {
        latitude: 48.13487,
        longitude: 11.58158,
    },
    {
        latitude: 48.13483,
        longitude: 11.58169,
    },
    {
        latitude: 48.13478,
        longitude: 11.58198,
    },
    {
        latitude: 48.13488,
        longitude: 11.58232,
    },
    {
        latitude: 48.135040000000004,
        longitude: 11.58273,
    },
    {
        latitude: 48.13514000000001,
        longitude: 11.58291,
    },
    {
        latitude: 48.13523000000001,
        longitude: 11.58305,
    },
    {
        latitude: 48.13543000000001,
        longitude: 11.58329,
    },
    {
        latitude: 48.135690000000004,
        longitude: 11.58357,
    },
    {
        latitude: 48.135960000000004,
        longitude: 11.58379,
    },
    {
        latitude: 48.13606000000001,
        longitude: 11.58386,
    },
    {
        latitude: 48.136300000000006,
        longitude: 11.58401,
    },
    {
        latitude: 48.13656,
        longitude: 11.58413,
    },
    {
        latitude: 48.136680000000005,
        longitude: 11.58417,
    },
    {
        latitude: 48.13712,
        longitude: 11.58432,
    },
    {
        latitude: 48.137220000000006,
        longitude: 11.58435,
    },
    {
        latitude: 48.13739,
        longitude: 11.5844,
    },
    {
        latitude: 48.137640000000005,
        longitude: 11.58447,
    },
    {
        latitude: 48.1379,
        longitude: 11.584539999999999,
    },
    {
        latitude: 48.138220000000004,
        longitude: 11.584629999999999,
    },
    {
        latitude: 48.138560000000005,
        longitude: 11.584739999999998,
    },
    {
        latitude: 48.138780000000004,
        longitude: 11.584799999999998,
    },
    {
        latitude: 48.13899000000001,
        longitude: 11.584859999999997,
    },
    {
        latitude: 48.13915000000001,
        longitude: 11.584889999999998,
    },
    {
        latitude: 48.13931000000001,
        longitude: 11.584839999999998,
    },
    {
        latitude: 48.139390000000006,
        longitude: 11.584779999999999,
    },
    {
        latitude: 48.13946000000001,
        longitude: 11.584719999999999,
    },
    {
        latitude: 48.13994000000001,
        longitude: 11.584169999999999,
    },
    {
        latitude: 48.14000000000001,
        longitude: 11.5841,
    },
    {
        latitude: 48.140130000000006,
        longitude: 11.5839,
    },
    {
        latitude: 48.140570000000004,
        longitude: 11.58343,
    },
    {
        latitude: 48.14077,
        longitude: 11.58322,
    },
    {
        latitude: 48.14094,
        longitude: 11.58314,
    },
    {
        latitude: 48.14116,
        longitude: 11.58308,
    },
    {
        latitude: 48.14156,
        longitude: 11.58317,
    },
    {
        latitude: 48.141619999999996,
        longitude: 11.583200000000001,
    },
    {
        latitude: 48.14236,
        longitude: 11.58355,
    },
    {
        latitude: 48.14279,
        longitude: 11.583770000000001,
    },
    {
        latitude: 48.1429,
        longitude: 11.583820000000001,
    },
    {
        latitude: 48.143429999999995,
        longitude: 11.584080000000002,
    },
    {
        latitude: 48.14362,
        longitude: 11.584160000000002,
    },
    {
        latitude: 48.14372,
        longitude: 11.584210000000002,
    },
    {
        latitude: 48.143820000000005,
        longitude: 11.584260000000002,
    },
    {
        latitude: 48.14374000000001,
        longitude: 11.584470000000001,
    },
    {
        latitude: 48.143710000000006,
        longitude: 11.584590000000002,
    },
    {
        latitude: 48.143530000000005,
        longitude: 11.585580000000002,
    },
    {
        latitude: 48.14349000000001,
        longitude: 11.585790000000001,
    },
    {
        latitude: 48.14341000000001,
        longitude: 11.58636,
    },
    {
        latitude: 48.14340000000001,
        longitude: 11.586580000000001,
    },
    {
        latitude: 48.143420000000006,
        longitude: 11.586760000000002,
    },
    {
        latitude: 48.143350000000005,
        longitude: 11.587150000000001,
    },
    {
        latitude: 48.14331000000001,
        longitude: 11.587320000000002,
    },
    {
        latitude: 48.1433,
        longitude: 11.587400000000002,
    },
    {
        latitude: 48.14323,
        longitude: 11.587790000000002,
    },
    {
        latitude: 48.1432,
        longitude: 11.587930000000002,
    },
    {
        latitude: 48.14313,
        longitude: 11.588290000000002,
    },
    {
        latitude: 48.143119999999996,
        longitude: 11.588350000000002,
    },
    {
        latitude: 48.14310999999999,
        longitude: 11.588390000000002,
    },
    {
        latitude: 48.14307999999999,
        longitude: 11.588550000000001,
    },
    {
        latitude: 48.14271999999999,
        longitude: 11.590250000000001,
    },
    {
        latitude: 48.14266999999999,
        longitude: 11.5905,
    },
    {
        latitude: 48.14249999999999,
        longitude: 11.59134,
    },
    {
        latitude: 48.14244999999999,
        longitude: 11.59158,
    },
    {
        latitude: 48.14233999999999,
        longitude: 11.592120000000001,
    },
    {
        latitude: 48.14216999999999,
        longitude: 11.592970000000001,
    },
    {
        latitude: 48.14207999999999,
        longitude: 11.59341,
    },
    {
        latitude: 48.14196999999999,
        longitude: 11.59398,
    },
    {
        latitude: 48.14186999999999,
        longitude: 11.59449,
    },
    {
        latitude: 48.14197999999999,
        longitude: 11.59453,
    },
    {
        latitude: 48.14244999999999,
        longitude: 11.59474,
    },
    {
        latitude: 48.14273999999999,
        longitude: 11.59486,
    },
    {
        latitude: 48.14300999999999,
        longitude: 11.59496,
    },
    {
        latitude: 48.14324999999999,
        longitude: 11.59505,
    },
    {
        latitude: 48.143419999999985,
        longitude: 11.5951,
    },
    {
        latitude: 48.14392999999998,
        longitude: 11.59523,
    },
    {
        latitude: 48.144269999999985,
        longitude: 11.5953,
    },
    {
        latitude: 48.14461999999998,
        longitude: 11.595369999999999,
    },
    {
        latitude: 48.14525999999998,
        longitude: 11.595509999999999,
    },
    {
        latitude: 48.14617999999998,
        longitude: 11.59569,
    },
    {
        latitude: 48.14646999999998,
        longitude: 11.59574,
    },
    {
        latitude: 48.14662999999998,
        longitude: 11.59577,
    },
    {
        latitude: 48.14671999999998,
        longitude: 11.59579,
    },
    {
        latitude: 48.14742999999998,
        longitude: 11.595939999999999,
    },
    {
        latitude: 48.14766999999998,
        longitude: 11.595999999999998,
    },
    {
        latitude: 48.147799999999975,
        longitude: 11.596069999999997,
    },
    {
        latitude: 48.14794999999997,
        longitude: 11.596159999999998,
    },
    {
        latitude: 48.148109999999974,
        longitude: 11.596239999999998,
    },
    {
        latitude: 48.14856999999997,
        longitude: 11.596629999999998,
    },
    {
        latitude: 48.14962999999997,
        longitude: 11.597569999999997,
    },
    {
        latitude: 48.14995999999997,
        longitude: 11.597879999999998,
    },
    {
        latitude: 48.15162999999997,
        longitude: 11.599379999999998,
    },
    {
        latitude: 48.15201999999997,
        longitude: 11.599719999999998,
    },
    {
        latitude: 48.152319999999975,
        longitude: 11.599969999999997,
    },
    {
        latitude: 48.15349999999997,
        longitude: 11.600919999999997,
    },
    {
        latitude: 48.15385999999997,
        longitude: 11.601179999999998,
    },
    {
        latitude: 48.15389999999997,
        longitude: 11.601209999999998,
    },
    {
        latitude: 48.15413999999997,
        longitude: 11.601379999999999,
    },
    {
        latitude: 48.15506999999997,
        longitude: 11.60211,
    },
    {
        latitude: 48.15533999999997,
        longitude: 11.60233,
    },
    {
        latitude: 48.155709999999964,
        longitude: 11.60263,
    },
    {
        latitude: 48.156029999999966,
        longitude: 11.60289,
    },
    {
        latitude: 48.156739999999964,
        longitude: 11.60344,
    },
    {
        latitude: 48.157349999999965,
        longitude: 11.60391,
    },
    {
        latitude: 48.15742999999996,
        longitude: 11.60396,
    },
    {
        latitude: 48.15768999999996,
        longitude: 11.60411,
    },
    {
        latitude: 48.15781999999996,
        longitude: 11.60416,
    },
    {
        latitude: 48.15797999999996,
        longitude: 11.60421,
    },
    {
        latitude: 48.15818999999996,
        longitude: 11.60423,
    },
    {
        latitude: 48.15844999999996,
        longitude: 11.60422,
    },
    {
        latitude: 48.15865999999996,
        longitude: 11.60416,
    },
    {
        latitude: 48.15874999999996,
        longitude: 11.60412,
    },
    {
        latitude: 48.158869999999965,
        longitude: 11.60404,
    },
    {
        latitude: 48.15894999999996,
        longitude: 11.60397,
    },
    {
        latitude: 48.15911999999996,
        longitude: 11.603760000000001,
    },
    {
        latitude: 48.15925999999996,
        longitude: 11.603520000000001,
    },
    {
        latitude: 48.15934999999996,
        longitude: 11.603280000000002,
    },
    {
        latitude: 48.15937999999996,
        longitude: 11.603150000000001,
    },
    {
        latitude: 48.15941999999996,
        longitude: 11.60284,
    },
    {
        latitude: 48.15940999999996,
        longitude: 11.60246,
    },
    {
        latitude: 48.15940999999996,
        longitude: 11.60233,
    },
    {
        latitude: 48.15943999999996,
        longitude: 11.602030000000001,
    },
    {
        latitude: 48.15946999999996,
        longitude: 11.601920000000002,
    },
    {
        latitude: 48.159539999999964,
        longitude: 11.601780000000002,
    },
    {
        latitude: 48.159609999999965,
        longitude: 11.60166,
    },
    {
        latitude: 48.159679999999966,
        longitude: 11.60157,
    },
    {
        latitude: 48.15997999999997,
        longitude: 11.60131,
    },
    {
        latitude: 48.160059999999966,
        longitude: 11.60123,
    },
    {
        latitude: 48.160209999999964,
        longitude: 11.60108,
    },
    {
        latitude: 48.16041999999997,
        longitude: 11.60083,
    },
    {
        latitude: 48.160679999999964,
        longitude: 11.60051,
    },
    {
        latitude: 48.16075999999996,
        longitude: 11.6004,
    },
    {
        latitude: 48.16081999999996,
        longitude: 11.60031,
    },
    {
        latitude: 48.16090999999996,
        longitude: 11.60017,
    },
    {
        latitude: 48.16123999999996,
        longitude: 11.59963,
    },
    {
        latitude: 48.161349999999956,
        longitude: 11.59944,
    },
    {
        latitude: 48.16144999999996,
        longitude: 11.59926,
    },
    {
        latitude: 48.16168999999996,
        longitude: 11.59884,
    },
    {
        latitude: 48.16182999999996,
        longitude: 11.598579999999998,
    },
    {
        latitude: 48.16241999999996,
        longitude: 11.597529999999999,
    },
    {
        latitude: 48.16250999999996,
        longitude: 11.59738,
    },
    {
        latitude: 48.16257999999996,
        longitude: 11.59727,
    },
    {
        latitude: 48.162719999999965,
        longitude: 11.59707,
    },
    {
        latitude: 48.16288999999996,
        longitude: 11.596860000000001,
    },
    {
        latitude: 48.162989999999965,
        longitude: 11.596750000000002,
    },
    {
        latitude: 48.16317999999997,
        longitude: 11.596580000000001,
    },
    {
        latitude: 48.16339999999997,
        longitude: 11.59641,
    },
    {
        latitude: 48.163679999999964,
        longitude: 11.596250000000001,
    },
    {
        latitude: 48.163949999999964,
        longitude: 11.596140000000002,
    },
    {
        latitude: 48.164129999999965,
        longitude: 11.596100000000002,
    },
    {
        latitude: 48.164399999999965,
        longitude: 11.596060000000001,
    },
    {
        latitude: 48.16453999999997,
        longitude: 11.596060000000001,
    },
    {
        latitude: 48.16476999999997,
        longitude: 11.59608,
    },
    {
        latitude: 48.16503999999997,
        longitude: 11.59614,
    },
    {
        latitude: 48.16530999999997,
        longitude: 11.59625,
    },
    {
        latitude: 48.16559999999997,
        longitude: 11.596409999999999,
    },
    {
        latitude: 48.16581999999997,
        longitude: 11.596549999999999,
    },
    {
        latitude: 48.166439999999966,
        longitude: 11.596979999999999,
    },
    {
        latitude: 48.16673999999997,
        longitude: 11.597179999999998,
    },
    {
        latitude: 48.167489999999965,
        longitude: 11.597699999999998,
    },
    {
        latitude: 48.16800999999997,
        longitude: 11.598099999999999,
    },
    {
        latitude: 48.16821999999997,
        longitude: 11.598249999999998,
    },
    {
        latitude: 48.16892999999997,
        longitude: 11.598709999999999,
    },
    {
        latitude: 48.16933999999997,
        longitude: 11.598999999999998,
    },
    {
        latitude: 48.16952999999997,
        longitude: 11.599129999999999,
    },
    {
        latitude: 48.170069999999974,
        longitude: 11.599499999999999,
    },
    {
        latitude: 48.17039999999997,
        longitude: 11.59973,
    },
    {
        latitude: 48.17057999999997,
        longitude: 11.59985,
    },
    {
        latitude: 48.17066999999997,
        longitude: 11.59991,
    },
    {
        latitude: 48.17093999999997,
        longitude: 11.60005,
    },
    {
        latitude: 48.171099999999974,
        longitude: 11.600109999999999,
    },
    {
        latitude: 48.17124999999997,
        longitude: 11.60014,
    },
    {
        latitude: 48.17153999999997,
        longitude: 11.60013,
    },
    {
        latitude: 48.17171999999997,
        longitude: 11.60007,
    },
    {
        latitude: 48.17189999999997,
        longitude: 11.59998,
    },
    {
        latitude: 48.17206999999997,
        longitude: 11.59985,
    },
    {
        latitude: 48.17220999999997,
        longitude: 11.59971,
    },
    {
        latitude: 48.17231999999997,
        longitude: 11.59957,
    },
    {
        latitude: 48.17243999999997,
        longitude: 11.59939,
    },
    {
        latitude: 48.172559999999976,
        longitude: 11.59918,
    },
    {
        latitude: 48.172799999999974,
        longitude: 11.59872,
    },
    {
        latitude: 48.173389999999976,
        longitude: 11.597480000000001,
    },
    {
        latitude: 48.17341999999998,
        longitude: 11.597430000000001,
    },
    {
        latitude: 48.17350999999998,
        longitude: 11.59735,
    },
    {
        latitude: 48.17365999999998,
        longitude: 11.597150000000001,
    },
    {
        latitude: 48.173809999999975,
        longitude: 11.596950000000001,
    },
    {
        latitude: 48.174119999999974,
        longitude: 11.596440000000001,
    },
    {
        latitude: 48.174729999999975,
        longitude: 11.59524,
    },
    {
        latitude: 48.17518999999997,
        longitude: 11.59431,
    },
    {
        latitude: 48.17536999999997,
        longitude: 11.59391,
    },
    {
        latitude: 48.17547999999997,
        longitude: 11.59371,
    },
    {
        latitude: 48.17556999999997,
        longitude: 11.59362,
    },
    {
        latitude: 48.17571999999997,
        longitude: 11.59358,
    },
    {
        latitude: 48.17576999999997,
        longitude: 11.59358,
    },
    {
        latitude: 48.17583999999997,
        longitude: 11.593599999999999,
    },
    {
        latitude: 48.17594999999997,
        longitude: 11.593649999999998,
    },
    {
        latitude: 48.17618999999997,
        longitude: 11.593799999999998,
    },
    {
        latitude: 48.17656999999997,
        longitude: 11.594069999999999,
    },
    {
        latitude: 48.17681999999997,
        longitude: 11.594249999999999,
    },
    {
        latitude: 48.17734999999997,
        longitude: 11.594619999999999,
    },
    {
        latitude: 48.17763999999997,
        longitude: 11.594759999999999,
    },
    {
        latitude: 48.17793999999997,
        longitude: 11.59502,
    },
    {
        latitude: 48.17810999999997,
        longitude: 11.59517,
    },
    {
        latitude: 48.17831999999997,
        longitude: 11.59535,
    },
    {
        latitude: 48.178889999999974,
        longitude: 11.59586,
    },
    {
        latitude: 48.17947999999998,
        longitude: 11.59642,
    },
    {
        latitude: 48.18055999999998,
        longitude: 11.59749,
    },
    {
        latitude: 48.18104999999998,
        longitude: 11.59801,
    },
    {
        latitude: 48.18134999999998,
        longitude: 11.59835,
    },
    {
        latitude: 48.18160999999998,
        longitude: 11.59867,
    },
    {
        latitude: 48.18198999999998,
        longitude: 11.59917,
    },
    {
        latitude: 48.18234999999998,
        longitude: 11.599710000000002,
    },
    {
        latitude: 48.18263999999998,
        longitude: 11.600200000000001,
    },
    {
        latitude: 48.182879999999976,
        longitude: 11.600660000000001,
    },
    {
        latitude: 48.18317999999998,
        longitude: 11.601320000000001,
    },
    {
        latitude: 48.183349999999976,
        longitude: 11.60176,
    },
    {
        latitude: 48.18350999999998,
        longitude: 11.60223,
    },
    {
        latitude: 48.18364999999998,
        longitude: 11.60269,
    },
    {
        latitude: 48.183819999999976,
        longitude: 11.60335,
    },
    {
        latitude: 48.18416999999997,
        longitude: 11.605080000000001,
    },
    {
        latitude: 48.18429999999997,
        longitude: 11.605640000000001,
    },
    {
        latitude: 48.184529999999974,
        longitude: 11.60646,
    },
    {
        latitude: 48.18480999999997,
        longitude: 11.60732,
    },
    {
        latitude: 48.18501999999997,
        longitude: 11.60787,
    },
    {
        latitude: 48.18521999999997,
        longitude: 11.60834,
    },
    {
        latitude: 48.18563999999997,
        longitude: 11.60922,
    },
    {
        latitude: 48.18599999999997,
        longitude: 11.60988,
    },
    {
        latitude: 48.18610999999997,
        longitude: 11.61006,
    },
    {
        latitude: 48.18661999999997,
        longitude: 11.61082,
    },
    {
        latitude: 48.18690999999997,
        longitude: 11.61121,
    },
    {
        latitude: 48.18738999999997,
        longitude: 11.61178,
    },
    {
        latitude: 48.18785999999997,
        longitude: 11.61225,
    },
    {
        latitude: 48.18822999999997,
        longitude: 11.612589999999999,
    },
    {
        latitude: 48.18853999999997,
        longitude: 11.61285,
    },
    {
        latitude: 48.188979999999965,
        longitude: 11.61318,
    },
    {
        latitude: 48.18907999999997,
        longitude: 11.613249999999999,
    },
    {
        latitude: 48.18928999999997,
        longitude: 11.613389999999999,
    },
    {
        latitude: 48.18975999999997,
        longitude: 11.613689999999998,
    },
    {
        latitude: 48.189949999999975,
        longitude: 11.613799999999998,
    },
    {
        latitude: 48.190309999999975,
        longitude: 11.613999999999997,
    },
    {
        latitude: 48.19100999999998,
        longitude: 11.614359999999998,
    },
    {
        latitude: 48.19197999999998,
        longitude: 11.614859999999998,
    },
    {
        latitude: 48.19395999999998,
        longitude: 11.615849999999998,
    },
    {
        latitude: 48.196089999999984,
        longitude: 11.616899999999998,
    },
    {
        latitude: 48.196789999999986,
        longitude: 11.617239999999997,
    },
    {
        latitude: 48.19779999999999,
        longitude: 11.617719999999997,
    },
    {
        latitude: 48.19820999999999,
        longitude: 11.617929999999996,
    },
    {
        latitude: 48.19847999999999,
        longitude: 11.618049999999997,
    },
    {
        latitude: 48.19866999999999,
        longitude: 11.618139999999997,
    },
    {
        latitude: 48.19924999999999,
        longitude: 11.618409999999997,
    },
    {
        latitude: 48.20009999999999,
        longitude: 11.618839999999997,
    },
    {
        latitude: 48.20036999999999,
        longitude: 11.618969999999997,
    },
    {
        latitude: 48.200779999999995,
        longitude: 11.619179999999997,
    },
    {
        latitude: 48.20166,
        longitude: 11.619629999999997,
    },
    {
        latitude: 48.20204,
        longitude: 11.619819999999997,
    },
    {
        latitude: 48.20243,
        longitude: 11.620019999999997,
    },
    {
        latitude: 48.20256,
        longitude: 11.620079999999996,
    },
    {
        latitude: 48.202999999999996,
        longitude: 11.620299999999997,
    },
    {
        latitude: 48.204209999999996,
        longitude: 11.620909999999997,
    },
    {
        latitude: 48.20516,
        longitude: 11.621379999999997,
    },
    {
        latitude: 48.20645,
        longitude: 11.622049999999996,
    },
    {
        latitude: 48.20704,
        longitude: 11.622339999999996,
    },
    {
        latitude: 48.20808,
        longitude: 11.622859999999996,
    },
    {
        latitude: 48.21016,
        longitude: 11.623919999999996,
    },
    {
        latitude: 48.210950000000004,
        longitude: 11.624309999999996,
    },
    {
        latitude: 48.211890000000004,
        longitude: 11.624799999999995,
    },
    {
        latitude: 48.21303,
        longitude: 11.625379999999994,
    },
    {
        latitude: 48.213460000000005,
        longitude: 11.625599999999995,
    },
    {
        latitude: 48.213930000000005,
        longitude: 11.625959999999996,
    },
    {
        latitude: 48.21473,
        longitude: 11.626479999999995,
    },
    {
        latitude: 48.215610000000005,
        longitude: 11.627099999999995,
    },
    {
        latitude: 48.21632,
        longitude: 11.627639999999996,
    },
    {
        latitude: 48.216620000000006,
        longitude: 11.627889999999995,
    },
    {
        latitude: 48.21725000000001,
        longitude: 11.628509999999995,
    },
    {
        latitude: 48.218050000000005,
        longitude: 11.629319999999995,
    },
    {
        latitude: 48.21920000000001,
        longitude: 11.630659999999995,
    },
    {
        latitude: 48.21954000000001,
        longitude: 11.631019999999996,
    },
    {
        latitude: 48.219710000000006,
        longitude: 11.631179999999995,
    },
    {
        latitude: 48.220020000000005,
        longitude: 11.631429999999995,
    },
    {
        latitude: 48.220130000000005,
        longitude: 11.631499999999994,
    },
    {
        latitude: 48.22026,
        longitude: 11.631559999999993,
    },
    {
        latitude: 48.220420000000004,
        longitude: 11.631619999999993,
    },
    {
        latitude: 48.220620000000004,
        longitude: 11.631679999999992,
    },
    {
        latitude: 48.22079,
        longitude: 11.631709999999993,
    },
    {
        latitude: 48.22097,
        longitude: 11.631719999999993,
    },
    {
        latitude: 48.22114,
        longitude: 11.631699999999993,
    },
    {
        latitude: 48.221309999999995,
        longitude: 11.631669999999993,
    },
    {
        latitude: 48.22147,
        longitude: 11.631609999999993,
    },
    {
        latitude: 48.221639999999994,
        longitude: 11.631539999999994,
    },
    {
        latitude: 48.22178999999999,
        longitude: 11.631449999999994,
    },
    {
        latitude: 48.22194999999999,
        longitude: 11.631339999999994,
    },
    {
        latitude: 48.22209999999999,
        longitude: 11.631199999999994,
    },
    {
        latitude: 48.22224999999999,
        longitude: 11.631059999999994,
    },
    {
        latitude: 48.22238999999999,
        longitude: 11.630889999999994,
    },
    {
        latitude: 48.22263999999999,
        longitude: 11.630499999999994,
    },
    {
        latitude: 48.222849999999994,
        longitude: 11.630059999999995,
    },
    {
        latitude: 48.22299999999999,
        longitude: 11.629589999999995,
    },
    {
        latitude: 48.22319999999999,
        longitude: 11.628709999999995,
    },
    {
        latitude: 48.22330999999999,
        longitude: 11.627909999999995,
    },
    {
        latitude: 48.22342999999999,
        longitude: 11.626699999999994,
    },
    {
        latitude: 48.22357999999999,
        longitude: 11.625449999999994,
    },
    {
        latitude: 48.223679999999995,
        longitude: 11.624819999999994,
    },
    {
        latitude: 48.2238,
        longitude: 11.624199999999995,
    },
    {
        latitude: 48.224019999999996,
        longitude: 11.623249999999995,
    },
    {
        latitude: 48.2245,
        longitude: 11.621519999999995,
    },
    {
        latitude: 48.22455,
        longitude: 11.621299999999994,
    },
    {
        latitude: 48.2246,
        longitude: 11.621109999999994,
    },
    {
        latitude: 48.22476,
        longitude: 11.620479999999995,
    },
    {
        latitude: 48.22513,
        longitude: 11.619349999999995,
    },
    {
        latitude: 48.22549,
        longitude: 11.618169999999996,
    },
    {
        latitude: 48.22557,
        longitude: 11.617909999999995,
    },
    {
        latitude: 48.22575,
        longitude: 11.617259999999995,
    },
    {
        latitude: 48.226119999999995,
        longitude: 11.615899999999995,
    },
    {
        latitude: 48.226229999999994,
        longitude: 11.615469999999995,
    },
    {
        latitude: 48.22666999999999,
        longitude: 11.613599999999995,
    },
    {
        latitude: 48.22695999999999,
        longitude: 11.612289999999994,
    },
    {
        latitude: 48.22701999999999,
        longitude: 11.612019999999994,
    },
    {
        latitude: 48.22723999999999,
        longitude: 11.611019999999995,
    },
    {
        latitude: 48.22750999999999,
        longitude: 11.609649999999995,
    },
    {
        latitude: 48.22759999999999,
        longitude: 11.609149999999994,
    },
    {
        latitude: 48.22781999999999,
        longitude: 11.607859999999995,
    },
    {
        latitude: 48.22786999999999,
        longitude: 11.607509999999996,
    },
    {
        latitude: 48.22800999999999,
        longitude: 11.606569999999996,
    },
    {
        latitude: 48.22822999999999,
        longitude: 11.604939999999996,
    },
    {
        latitude: 48.22836999999999,
        longitude: 11.603759999999996,
    },
    {
        latitude: 48.22850999999999,
        longitude: 11.602709999999997,
    },
    {
        latitude: 48.228629999999995,
        longitude: 11.601389999999997,
    },
    {
        latitude: 48.22868,
        longitude: 11.600849999999996,
    },
    {
        latitude: 48.22877,
        longitude: 11.599669999999996,
    },
    {
        latitude: 48.22888,
        longitude: 11.597059999999995,
    },
    {
        latitude: 48.228919999999995,
        longitude: 11.595609999999995,
    },
    {
        latitude: 48.22895,
        longitude: 11.593619999999996,
    },
    {
        latitude: 48.22893,
        longitude: 11.592019999999996,
    },
    {
        latitude: 48.22891,
        longitude: 11.590809999999996,
    },
    {
        latitude: 48.22883,
        longitude: 11.589249999999996,
    },
    {
        latitude: 48.22878,
        longitude: 11.588079999999996,
    },
    {
        latitude: 48.22869,
        longitude: 11.586629999999996,
    },
    {
        latitude: 48.22864,
        longitude: 11.585899999999995,
    },
    {
        latitude: 48.228519999999996,
        longitude: 11.584419999999994,
    },
    {
        latitude: 48.22841,
        longitude: 11.583079999999994,
    },
    {
        latitude: 48.228379999999994,
        longitude: 11.582749999999994,
    },
    {
        latitude: 48.228359999999995,
        longitude: 11.582539999999995,
    },
    {
        latitude: 48.22825999999999,
        longitude: 11.581429999999994,
    },
    {
        latitude: 48.22804999999999,
        longitude: 11.579119999999994,
    },
    {
        latitude: 48.227859999999986,
        longitude: 11.577149999999994,
    },
    {
        latitude: 48.22779999999999,
        longitude: 11.576469999999995,
    },
    {
        latitude: 48.22772999999999,
        longitude: 11.575749999999996,
    },
    {
        latitude: 48.227569999999986,
        longitude: 11.573829999999996,
    },
    {
        latitude: 48.22753999999998,
        longitude: 11.573459999999995,
    },
    {
        latitude: 48.22744999999998,
        longitude: 11.572189999999996,
    },
    {
        latitude: 48.227369999999986,
        longitude: 11.571229999999996,
    },
    {
        latitude: 48.22726999999998,
        longitude: 11.569919999999996,
    },
    {
        latitude: 48.227189999999986,
        longitude: 11.568599999999996,
    },
    {
        latitude: 48.22708999999998,
        longitude: 11.566859999999997,
    },
    {
        latitude: 48.227009999999986,
        longitude: 11.564839999999997,
    },
    {
        latitude: 48.226959999999984,
        longitude: 11.562969999999996,
    },
    {
        latitude: 48.226919999999986,
        longitude: 11.561669999999996,
    },
    {
        latitude: 48.22690999999998,
        longitude: 11.560529999999996,
    },
    {
        latitude: 48.22687999999998,
        longitude: 11.559469999999996,
    },
    {
        latitude: 48.22683999999998,
        longitude: 11.557069999999996,
    },
    {
        latitude: 48.22681999999998,
        longitude: 11.555779999999997,
    },
    {
        latitude: 48.226779999999984,
        longitude: 11.554059999999996,
    },
    {
        latitude: 48.22674999999998,
        longitude: 11.552849999999996,
    },
    {
        latitude: 48.22673999999998,
        longitude: 11.552099999999996,
    },
    {
        latitude: 48.226729999999975,
        longitude: 11.551509999999995,
    },
    {
        latitude: 48.22671999999997,
        longitude: 11.551209999999996,
    },
    {
        latitude: 48.22670999999997,
        longitude: 11.550829999999996,
    },
    {
        latitude: 48.22666999999997,
        longitude: 11.549439999999995,
    },
    {
        latitude: 48.22660999999997,
        longitude: 11.547739999999996,
    },
    {
        latitude: 48.22655999999997,
        longitude: 11.546539999999995,
    },
    {
        latitude: 48.22640999999997,
        longitude: 11.543759999999995,
    },
    {
        latitude: 48.226349999999975,
        longitude: 11.542939999999996,
    },
    {
        latitude: 48.22621999999998,
        longitude: 11.541399999999996,
    },
    {
        latitude: 48.226129999999976,
        longitude: 11.540419999999996,
    },
    {
        latitude: 48.22602999999997,
        longitude: 11.539309999999995,
    },
    {
        latitude: 48.22590999999997,
        longitude: 11.538229999999995,
    },
    {
        latitude: 48.22588999999997,
        longitude: 11.538009999999995,
    },
    {
        latitude: 48.22577999999997,
        longitude: 11.537019999999995,
    },
    {
        latitude: 48.225449999999974,
        longitude: 11.534629999999995,
    },
    {
        latitude: 48.22539999999997,
        longitude: 11.534299999999995,
    },
    {
        latitude: 48.22532999999997,
        longitude: 11.533879999999995,
    },
    {
        latitude: 48.22526999999997,
        longitude: 11.533499999999995,
    },
    {
        latitude: 48.224939999999975,
        longitude: 11.531379999999995,
    },
    {
        latitude: 48.224689999999974,
        longitude: 11.530009999999995,
    },
    {
        latitude: 48.22454999999997,
        longitude: 11.529229999999995,
    },
    {
        latitude: 48.22435999999997,
        longitude: 11.528289999999995,
    },
    {
        latitude: 48.22388999999997,
        longitude: 11.526089999999995,
    },
    {
        latitude: 48.22353999999997,
        longitude: 11.524539999999995,
    },
    {
        latitude: 48.22304999999997,
        longitude: 11.522589999999994,
    },
    {
        latitude: 48.22282999999997,
        longitude: 11.521739999999994,
    },
    {
        latitude: 48.222699999999975,
        longitude: 11.521289999999993,
    },
    {
        latitude: 48.222449999999974,
        longitude: 11.520389999999994,
    },
    {
        latitude: 48.22228999999997,
        longitude: 11.519849999999993,
    },
    {
        latitude: 48.221869999999974,
        longitude: 11.518459999999992,
    },
    {
        latitude: 48.22154999999997,
        longitude: 11.517459999999993,
    },
    {
        latitude: 48.22080999999997,
        longitude: 11.515299999999993,
    },
    {
        latitude: 48.22019999999997,
        longitude: 11.513629999999992,
    },
    {
        latitude: 48.21980999999997,
        longitude: 11.512629999999993,
    },
    {
        latitude: 48.21929999999997,
        longitude: 11.511369999999992,
    },
    {
        latitude: 48.21913999999997,
        longitude: 11.510989999999993,
    },
    {
        latitude: 48.218369999999965,
        longitude: 11.509219999999992,
    },
    {
        latitude: 48.217679999999966,
        longitude: 11.507739999999991,
    },
    {
        latitude: 48.216759999999965,
        longitude: 11.50587999999999,
    },
    {
        latitude: 48.215949999999964,
        longitude: 11.50434999999999,
    },
    {
        latitude: 48.215569999999964,
        longitude: 11.50365999999999,
    },
    {
        latitude: 48.214859999999966,
        longitude: 11.50242999999999,
    },
    {
        latitude: 48.214119999999966,
        longitude: 11.50120999999999,
    },
    {
        latitude: 48.213419999999964,
        longitude: 11.50010999999999,
    },
    {
        latitude: 48.212709999999966,
        longitude: 11.49899999999999,
    },
    {
        latitude: 48.212419999999966,
        longitude: 11.49850999999999,
    },
    {
        latitude: 48.21192999999997,
        longitude: 11.497609999999991,
    },
    {
        latitude: 48.21150999999997,
        longitude: 11.49673999999999,
    },
    {
        latitude: 48.211119999999966,
        longitude: 11.495829999999991,
    },
    {
        latitude: 48.210669999999965,
        longitude: 11.494639999999992,
    },
    {
        latitude: 48.21032999999996,
        longitude: 11.493559999999992,
    },
    {
        latitude: 48.210159999999966,
        longitude: 11.492959999999991,
    },
    {
        latitude: 48.20987999999997,
        longitude: 11.491829999999991,
    },
    {
        latitude: 48.20976999999997,
        longitude: 11.491319999999991,
    },
    {
        latitude: 48.20958999999997,
        longitude: 11.49034999999999,
    },
    {
        latitude: 48.20951999999997,
        longitude: 11.489909999999991,
    },
    {
        latitude: 48.20936999999997,
        longitude: 11.48889999999999,
    },
    {
        latitude: 48.20932999999997,
        longitude: 11.48855999999999,
    },
    {
        latitude: 48.20921999999997,
        longitude: 11.487269999999992,
    },
    {
        latitude: 48.209179999999975,
        longitude: 11.486499999999992,
    },
    {
        latitude: 48.20916999999997,
        longitude: 11.485989999999992,
    },
    {
        latitude: 48.20916999999997,
        longitude: 11.484889999999993,
    },
    {
        latitude: 48.20920999999997,
        longitude: 11.483929999999994,
    },
    {
        latitude: 48.20923999999997,
        longitude: 11.483369999999994,
    },
    {
        latitude: 48.209289999999974,
        longitude: 11.482779999999993,
    },
    {
        latitude: 48.20931999999998,
        longitude: 11.482379999999992,
    },
    {
        latitude: 48.20936999999998,
        longitude: 11.482019999999991,
    },
    {
        latitude: 48.209429999999976,
        longitude: 11.481509999999991,
    },
    {
        latitude: 48.20954999999998,
        longitude: 11.480529999999991,
    },
    {
        latitude: 48.20965999999998,
        longitude: 11.47974999999999,
    },
    {
        latitude: 48.20972999999998,
        longitude: 11.47909999999999,
    },
    {
        latitude: 48.20981999999998,
        longitude: 11.47781999999999,
    },
    {
        latitude: 48.20983999999998,
        longitude: 11.47707999999999,
    },
    {
        latitude: 48.20985999999998,
        longitude: 11.476259999999991,
    },
    {
        latitude: 48.209849999999975,
        longitude: 11.473099999999992,
    },
    {
        latitude: 48.209829999999975,
        longitude: 11.470969999999992,
    },
    {
        latitude: 48.20981999999997,
        longitude: 11.469879999999993,
    },
    {
        latitude: 48.20981999999997,
        longitude: 11.469389999999994,
    },
    {
        latitude: 48.209759999999974,
        longitude: 11.468339999999994,
    },
    {
        latitude: 48.209669999999974,
        longitude: 11.467429999999995,
    },
    {
        latitude: 48.20952999999997,
        longitude: 11.466609999999996,
    },
    {
        latitude: 48.20942999999997,
        longitude: 11.466099999999996,
    },
    {
        latitude: 48.209329999999966,
        longitude: 11.465669999999996,
    },
    {
        latitude: 48.209099999999964,
        longitude: 11.464789999999995,
    },
    {
        latitude: 48.20895999999996,
        longitude: 11.464359999999996,
    },
    {
        latitude: 48.20877999999996,
        longitude: 11.463889999999996,
    },
    {
        latitude: 48.20836999999996,
        longitude: 11.462989999999996,
    },
    {
        latitude: 48.20814999999996,
        longitude: 11.462549999999997,
    },
    {
        latitude: 48.20804999999996,
        longitude: 11.462349999999997,
    },
    {
        latitude: 48.207659999999954,
        longitude: 11.461719999999998,
    },
    {
        latitude: 48.20655999999995,
        longitude: 11.459959999999997,
    },
    {
        latitude: 48.206339999999955,
        longitude: 11.459549999999997,
    },
    {
        latitude: 48.205959999999955,
        longitude: 11.458789999999997,
    },
    {
        latitude: 48.20569999999996,
        longitude: 11.458159999999998,
    },
    {
        latitude: 48.205469999999956,
        longitude: 11.457549999999998,
    },
    {
        latitude: 48.205379999999955,
        longitude: 11.457259999999998,
    },
    {
        latitude: 48.20520999999996,
        longitude: 11.456669999999997,
    },
    {
        latitude: 48.205019999999955,
        longitude: 11.455899999999998,
    },
    {
        latitude: 48.204859999999954,
        longitude: 11.455059999999998,
    },
    {
        latitude: 48.20477999999996,
        longitude: 11.454479999999998,
    },
    {
        latitude: 48.204729999999955,
        longitude: 11.454049999999999,
    },
    {
        latitude: 48.20469999999995,
        longitude: 11.453809999999999,
    },
    {
        latitude: 48.204659999999954,
        longitude: 11.453249999999999,
    },
    {
        latitude: 48.204619999999956,
        longitude: 11.452609999999998,
    },
    {
        latitude: 48.204569999999954,
        longitude: 11.451479999999998,
    },
    {
        latitude: 48.20455999999995,
        longitude: 11.451199999999998,
    },
    {
        latitude: 48.20451999999995,
        longitude: 11.450039999999998,
    },
    {
        latitude: 48.20449999999995,
        longitude: 11.448969999999997,
    },
    {
        latitude: 48.20448999999995,
        longitude: 11.448639999999997,
    },
    {
        latitude: 48.20446999999995,
        longitude: 11.448029999999997,
    },
    {
        latitude: 48.20440999999995,
        longitude: 11.446259999999997,
    },
    {
        latitude: 48.20444999999995,
        longitude: 11.445749999999997,
    },
    {
        latitude: 48.204459999999955,
        longitude: 11.445249999999996,
    },
    {
        latitude: 48.20442999999995,
        longitude: 11.444269999999996,
    },
    {
        latitude: 48.204369999999955,
        longitude: 11.443379999999996,
    },
    {
        latitude: 48.20421999999996,
        longitude: 11.441429999999995,
    },
    {
        latitude: 48.20415999999996,
        longitude: 11.440299999999995,
    },
    {
        latitude: 48.20412999999996,
        longitude: 11.439359999999995,
    },
    {
        latitude: 48.20411999999995,
        longitude: 11.438159999999995,
    },
    {
        latitude: 48.204149999999956,
        longitude: 11.437099999999994,
    },
    {
        latitude: 48.20440999999995,
        longitude: 11.432309999999994,
    },
    {
        latitude: 48.20442999999995,
        longitude: 11.431949999999993,
    },
    {
        latitude: 48.20444999999995,
        longitude: 11.431629999999993,
    },
    {
        latitude: 48.204639999999955,
        longitude: 11.428369999999994,
    },
    {
        latitude: 48.204749999999954,
        longitude: 11.426499999999994,
    },
    {
        latitude: 48.205019999999955,
        longitude: 11.421929999999994,
    },
    {
        latitude: 48.205939999999956,
        longitude: 11.405729999999995,
    },
    {
        latitude: 48.20598999999996,
        longitude: 11.404659999999994,
    },
    {
        latitude: 48.206029999999956,
        longitude: 11.403999999999995,
    },
    {
        latitude: 48.206049999999955,
        longitude: 11.403679999999994,
    },
    {
        latitude: 48.20605999999996,
        longitude: 11.403409999999994,
    },
    {
        latitude: 48.20617999999996,
        longitude: 11.401479999999994,
    },
    {
        latitude: 48.20624999999996,
        longitude: 11.400499999999994,
    },
    {
        latitude: 48.20626999999996,
        longitude: 11.400189999999993,
    },
    {
        latitude: 48.206279999999964,
        longitude: 11.400019999999992,
    },
    {
        latitude: 48.206369999999964,
        longitude: 11.398869999999992,
    },
    {
        latitude: 48.206529999999965,
        longitude: 11.397179999999992,
    },
    {
        latitude: 48.206689999999966,
        longitude: 11.395849999999992,
    },
    {
        latitude: 48.20676999999996,
        longitude: 11.395339999999992,
    },
    {
        latitude: 48.20689999999996,
        longitude: 11.394679999999992,
    },
    {
        latitude: 48.20705999999996,
        longitude: 11.394059999999993,
    },
    {
        latitude: 48.207219999999964,
        longitude: 11.393559999999992,
    },
    {
        latitude: 48.20738999999996,
        longitude: 11.393109999999991,
    },
    {
        latitude: 48.20758999999996,
        longitude: 11.39265999999999,
    },
    {
        latitude: 48.20788999999996,
        longitude: 11.39204999999999,
    },
    {
        latitude: 48.208159999999964,
        longitude: 11.39156999999999,
    },
    {
        latitude: 48.20825999999997,
        longitude: 11.39139999999999,
    },
    {
        latitude: 48.20883999999997,
        longitude: 11.39041999999999,
    },
    {
        latitude: 48.20908999999997,
        longitude: 11.38986999999999,
    },
    {
        latitude: 48.20929999999997,
        longitude: 11.389509999999989,
    },
    {
        latitude: 48.21061999999997,
        longitude: 11.387279999999988,
    },
    {
        latitude: 48.21076999999997,
        longitude: 11.387019999999987,
    },
    {
        latitude: 48.21087999999997,
        longitude: 11.386839999999987,
    },
    {
        latitude: 48.21161999999997,
        longitude: 11.385569999999987,
    },
    {
        latitude: 48.212039999999966,
        longitude: 11.384879999999987,
    },
    {
        latitude: 48.21631999999997,
        longitude: 11.377599999999987,
    },
    {
        latitude: 48.21658999999997,
        longitude: 11.377139999999986,
    },
    {
        latitude: 48.21694999999997,
        longitude: 11.376539999999986,
    },
    {
        latitude: 48.21704999999997,
        longitude: 11.376369999999985,
    },
    {
        latitude: 48.221089999999975,
        longitude: 11.369509999999986,
    },
    {
        latitude: 48.22322999999997,
        longitude: 11.365899999999986,
    },
    {
        latitude: 48.226079999999975,
        longitude: 11.361049999999986,
    },
    {
        latitude: 48.22621999999998,
        longitude: 11.360809999999987,
    },
    {
        latitude: 48.226529999999975,
        longitude: 11.360279999999987,
    },
    {
        latitude: 48.22884999999997,
        longitude: 11.356339999999987,
    },
    {
        latitude: 48.229389999999974,
        longitude: 11.355429999999988,
    },
    {
        latitude: 48.23033999999998,
        longitude: 11.353809999999987,
    },
    {
        latitude: 48.23061999999997,
        longitude: 11.353329999999987,
    },
    {
        latitude: 48.23074999999997,
        longitude: 11.353119999999988,
    },
    {
        latitude: 48.23139999999997,
        longitude: 11.352009999999987,
    },
    {
        latitude: 48.23192999999997,
        longitude: 11.351119999999987,
    },
    {
        latitude: 48.23276999999997,
        longitude: 11.349669999999987,
    },
    {
        latitude: 48.23290999999997,
        longitude: 11.349439999999987,
    },
    {
        latitude: 48.23311999999997,
        longitude: 11.349079999999987,
    },
    {
        latitude: 48.233329999999974,
        longitude: 11.348729999999987,
    },
    {
        latitude: 48.233559999999976,
        longitude: 11.348349999999988,
    },
    {
        latitude: 48.23374999999998,
        longitude: 11.348029999999987,
    },
    {
        latitude: 48.23509999999998,
        longitude: 11.345709999999988,
    },
    {
        latitude: 48.23537999999998,
        longitude: 11.345229999999988,
    },
    {
        latitude: 48.23600999999998,
        longitude: 11.344109999999988,
    },
    {
        latitude: 48.23669999999998,
        longitude: 11.342859999999988,
    },
    {
        latitude: 48.237609999999975,
        longitude: 11.341149999999988,
    },
    {
        latitude: 48.238299999999974,
        longitude: 11.339819999999989,
    },
    {
        latitude: 48.239489999999975,
        longitude: 11.337429999999989,
    },
    {
        latitude: 48.24249999999998,
        longitude: 11.33125999999999,
    },
    {
        latitude: 48.244529999999976,
        longitude: 11.32710999999999,
    },
    {
        latitude: 48.250879999999974,
        longitude: 11.314089999999991,
    },
    {
        latitude: 48.252339999999975,
        longitude: 11.31109999999999,
    },
    {
        latitude: 48.252849999999974,
        longitude: 11.310049999999991,
    },
    {
        latitude: 48.25315999999997,
        longitude: 11.30940999999999,
    },
    {
        latitude: 48.25342999999997,
        longitude: 11.30885999999999,
    },
    {
        latitude: 48.25388999999997,
        longitude: 11.30791999999999,
    },
    {
        latitude: 48.25485999999997,
        longitude: 11.30593999999999,
    },
    {
        latitude: 48.25531999999997,
        longitude: 11.30500999999999,
    },
    {
        latitude: 48.25551999999997,
        longitude: 11.30462999999999,
    },
    {
        latitude: 48.255779999999966,
        longitude: 11.30415999999999,
    },
    {
        latitude: 48.25638999999997,
        longitude: 11.303159999999991,
    },
    {
        latitude: 48.25652999999997,
        longitude: 11.30293999999999,
    },
    {
        latitude: 48.25709999999997,
        longitude: 11.30208999999999,
    },
    {
        latitude: 48.257599999999975,
        longitude: 11.30139999999999,
    },
    {
        latitude: 48.257889999999975,
        longitude: 11.30101999999999,
    },
    {
        latitude: 48.258359999999975,
        longitude: 11.30045999999999,
    },
    {
        latitude: 48.25852999999997,
        longitude: 11.30025999999999,
    },
    {
        latitude: 48.25914999999997,
        longitude: 11.29956999999999,
    },
    {
        latitude: 48.25992999999997,
        longitude: 11.29875999999999,
    },
    {
        latitude: 48.26019999999997,
        longitude: 11.298469999999991,
    },
    {
        latitude: 48.26133999999997,
        longitude: 11.297279999999992,
    },
    {
        latitude: 48.26229999999997,
        longitude: 11.296279999999992,
    },
    {
        latitude: 48.262669999999964,
        longitude: 11.295889999999993,
    },
    {
        latitude: 48.26301999999996,
        longitude: 11.295519999999993,
    },
    {
        latitude: 48.27062999999996,
        longitude: 11.287539999999993,
    },
    {
        latitude: 48.270929999999964,
        longitude: 11.287239999999994,
    },
    {
        latitude: 48.27133999999997,
        longitude: 11.286789999999993,
    },
    {
        latitude: 48.27227999999997,
        longitude: 11.285799999999993,
    },
    {
        latitude: 48.27279999999997,
        longitude: 11.285209999999992,
    },
    {
        latitude: 48.273599999999966,
        longitude: 11.284209999999993,
    },
    {
        latitude: 48.27409999999997,
        longitude: 11.283529999999994,
    },
    {
        latitude: 48.27433999999997,
        longitude: 11.283179999999994,
    },
    {
        latitude: 48.274829999999966,
        longitude: 11.282419999999995,
    },
    {
        latitude: 48.275409999999965,
        longitude: 11.281439999999995,
    },
    {
        latitude: 48.27593999999996,
        longitude: 11.280459999999994,
    },
    {
        latitude: 48.27639999999996,
        longitude: 11.279539999999994,
    },
    {
        latitude: 48.27663999999996,
        longitude: 11.279019999999994,
    },
    {
        latitude: 48.27673999999996,
        longitude: 11.278809999999995,
    },
    {
        latitude: 48.27729999999996,
        longitude: 11.277639999999995,
    },
    {
        latitude: 48.27747999999996,
        longitude: 11.277259999999995,
    },
    {
        latitude: 48.277869999999965,
        longitude: 11.276429999999994,
    },
    {
        latitude: 48.278899999999965,
        longitude: 11.274249999999995,
    },
    {
        latitude: 48.27977999999997,
        longitude: 11.272349999999996,
    },
    {
        latitude: 48.28005999999996,
        longitude: 11.271759999999995,
    },
    {
        latitude: 48.28029999999996,
        longitude: 11.271219999999994,
    },
    {
        latitude: 48.281359999999964,
        longitude: 11.268959999999995,
    },
    {
        latitude: 48.282299999999964,
        longitude: 11.266929999999995,
    },
    {
        latitude: 48.282419999999966,
        longitude: 11.266669999999994,
    },
    {
        latitude: 48.28320999999997,
        longitude: 11.265009999999995,
    },
    {
        latitude: 48.28535999999997,
        longitude: 11.260359999999995,
    },
    {
        latitude: 48.28609999999997,
        longitude: 11.258719999999995,
    },
    {
        latitude: 48.28652999999997,
        longitude: 11.257729999999995,
    },
    {
        latitude: 48.28745999999997,
        longitude: 11.255509999999996,
    },
    {
        latitude: 48.28790999999997,
        longitude: 11.254369999999996,
    },
    {
        latitude: 48.28868999999997,
        longitude: 11.252289999999997,
    },
    {
        latitude: 48.289149999999964,
        longitude: 11.250959999999997,
    },
    {
        latitude: 48.289779999999965,
        longitude: 11.249019999999998,
    },
    {
        latitude: 48.290179999999964,
        longitude: 11.247749999999998,
    },
    {
        latitude: 48.29094999999997,
        longitude: 11.245219999999998,
    },
    {
        latitude: 48.29511999999997,
        longitude: 11.231189999999998,
    },
    {
        latitude: 48.29547999999997,
        longitude: 11.230039999999997,
    },
    {
        latitude: 48.29616999999997,
        longitude: 11.227979999999997,
    },
    {
        latitude: 48.29650999999997,
        longitude: 11.227039999999997,
    },
    {
        latitude: 48.29717999999997,
        longitude: 11.225319999999996,
    },
    {
        latitude: 48.29773999999997,
        longitude: 11.223979999999996,
    },
    {
        latitude: 48.29814999999997,
        longitude: 11.223069999999996,
    },
    {
        latitude: 48.29879999999997,
        longitude: 11.221689999999997,
    },
    {
        latitude: 48.29921999999997,
        longitude: 11.220849999999997,
    },
    {
        latitude: 48.30020999999997,
        longitude: 11.218979999999997,
    },
    {
        latitude: 48.30101999999997,
        longitude: 11.217589999999996,
    },
    {
        latitude: 48.30197999999997,
        longitude: 11.216059999999995,
    },
    {
        latitude: 48.303019999999975,
        longitude: 11.214489999999996,
    },
    {
        latitude: 48.30488999999997,
        longitude: 11.211759999999996,
    },
    {
        latitude: 48.30676999999997,
        longitude: 11.209009999999996,
    },
    {
        latitude: 48.307339999999975,
        longitude: 11.208179999999995,
    },
    {
        latitude: 48.30756999999998,
        longitude: 11.207869999999994,
    },
    {
        latitude: 48.307809999999975,
        longitude: 11.207519999999995,
    },
    {
        latitude: 48.30783999999998,
        longitude: 11.207479999999995,
    },
    {
        latitude: 48.308299999999974,
        longitude: 11.206769999999995,
    },
    {
        latitude: 48.30935999999998,
        longitude: 11.205239999999995,
    },
    {
        latitude: 48.30982999999998,
        longitude: 11.204539999999994,
    },
    {
        latitude: 48.31052999999998,
        longitude: 11.203519999999994,
    },
    {
        latitude: 48.31232999999998,
        longitude: 11.200889999999994,
    },
    {
        latitude: 48.313679999999984,
        longitude: 11.198859999999994,
    },
    {
        latitude: 48.314599999999984,
        longitude: 11.197429999999995,
    },
    {
        latitude: 48.31480999999999,
        longitude: 11.197069999999995,
    },
    {
        latitude: 48.31546999999999,
        longitude: 11.195969999999996,
    },
    {
        latitude: 48.31646999999999,
        longitude: 11.194219999999996,
    },
    {
        latitude: 48.31669999999999,
        longitude: 11.193809999999996,
    },
    {
        latitude: 48.31730999999999,
        longitude: 11.192679999999996,
    },
    {
        latitude: 48.31779999999999,
        longitude: 11.191729999999996,
    },
    {
        latitude: 48.31866999999999,
        longitude: 11.189979999999997,
    },
    {
        latitude: 48.31951999999999,
        longitude: 11.188179999999997,
    },
    {
        latitude: 48.32062999999999,
        longitude: 11.185799999999997,
    },
    {
        latitude: 48.32269999999999,
        longitude: 11.181279999999997,
    },
    {
        latitude: 48.32290999999999,
        longitude: 11.180849999999998,
    },
    {
        latitude: 48.32511999999999,
        longitude: 11.176049999999998,
    },
    {
        latitude: 48.32613999999999,
        longitude: 11.173929999999999,
    },
    {
        latitude: 48.32664999999999,
        longitude: 11.172909999999998,
    },
    {
        latitude: 48.32739999999998,
        longitude: 11.171449999999998,
    },
    {
        latitude: 48.32799999999998,
        longitude: 11.170359999999999,
    },
    {
        latitude: 48.328789999999984,
        longitude: 11.168999999999999,
    },
    {
        latitude: 48.32942999999998,
        longitude: 11.167959999999999,
    },
    {
        latitude: 48.32960999999998,
        longitude: 11.167689999999999,
    },
    {
        latitude: 48.32987999999998,
        longitude: 11.167279999999998,
    },
    {
        latitude: 48.330449999999985,
        longitude: 11.166449999999998,
    },
    {
        latitude: 48.330649999999984,
        longitude: 11.166169999999997,
    },
    {
        latitude: 48.33092999999998,
        longitude: 11.165799999999997,
    },
    {
        latitude: 48.33133999999998,
        longitude: 11.165259999999996,
    },
    {
        latitude: 48.331839999999985,
        longitude: 11.164639999999997,
    },
    {
        latitude: 48.332349999999984,
        longitude: 11.164039999999996,
    },
    {
        latitude: 48.33300999999999,
        longitude: 11.163329999999997,
    },
    {
        latitude: 48.333649999999984,
        longitude: 11.162699999999997,
    },
    {
        latitude: 48.336019999999984,
        longitude: 11.160499999999997,
    },
    {
        latitude: 48.33677999999998,
        longitude: 11.159769999999996,
    },
    {
        latitude: 48.33771999999998,
        longitude: 11.158809999999997,
    },
    {
        latitude: 48.33808999999998,
        longitude: 11.158399999999997,
    },
    {
        latitude: 48.33850999999998,
        longitude: 11.157909999999998,
    },
    {
        latitude: 48.33924999999998,
        longitude: 11.156959999999998,
    },
    {
        latitude: 48.33978999999998,
        longitude: 11.156199999999998,
    },
    {
        latitude: 48.34048999999998,
        longitude: 11.155089999999998,
    },
    {
        latitude: 48.34075999999998,
        longitude: 11.154629999999997,
    },
    {
        latitude: 48.34111999999998,
        longitude: 11.153979999999997,
    },
    {
        latitude: 48.341329999999985,
        longitude: 11.153589999999998,
    },
    {
        latitude: 48.34173999999999,
        longitude: 11.152779999999998,
    },
    {
        latitude: 48.342109999999984,
        longitude: 11.152009999999999,
    },
    {
        latitude: 48.34337999999998,
        longitude: 11.149309999999998,
    },
    {
        latitude: 48.344149999999985,
        longitude: 11.147639999999997,
    },
    {
        latitude: 48.34496999999998,
        longitude: 11.145889999999998,
    },
    {
        latitude: 48.34556999999998,
        longitude: 11.144589999999997,
    },
    {
        latitude: 48.34601999999998,
        longitude: 11.143639999999998,
    },
    {
        latitude: 48.34671999999998,
        longitude: 11.142149999999997,
    },
    {
        latitude: 48.346969999999985,
        longitude: 11.141639999999997,
    },
    {
        latitude: 48.34755999999999,
        longitude: 11.140489999999996,
    },
    {
        latitude: 48.34802999999999,
        longitude: 11.139659999999996,
    },
    {
        latitude: 48.34838999999999,
        longitude: 11.139059999999995,
    },
    {
        latitude: 48.349099999999986,
        longitude: 11.137979999999995,
    },
    {
        latitude: 48.349389999999985,
        longitude: 11.137569999999995,
    },
    {
        latitude: 48.34955999999998,
        longitude: 11.137339999999995,
    },
    {
        latitude: 48.350149999999985,
        longitude: 11.136569999999995,
    },
    {
        latitude: 48.35044999999999,
        longitude: 11.136199999999995,
    },
    {
        latitude: 48.35066999999999,
        longitude: 11.135959999999995,
    },
    {
        latitude: 48.351069999999986,
        longitude: 11.135469999999996,
    },
    {
        latitude: 48.35131999999999,
        longitude: 11.135189999999996,
    },
    {
        latitude: 48.35169999999999,
        longitude: 11.134789999999995,
    },
    {
        latitude: 48.35214999999999,
        longitude: 11.134339999999995,
    },
    {
        latitude: 48.353149999999985,
        longitude: 11.133449999999995,
    },
    {
        latitude: 48.35355999999999,
        longitude: 11.133119999999995,
    },
    {
        latitude: 48.35396999999999,
        longitude: 11.132819999999995,
    },
    {
        latitude: 48.35406999999999,
        longitude: 11.132729999999995,
    },
    {
        latitude: 48.35444999999999,
        longitude: 11.132389999999996,
    },
    {
        latitude: 48.35537999999999,
        longitude: 11.131609999999995,
    },
    {
        latitude: 48.35575999999999,
        longitude: 11.131289999999995,
    },
    {
        latitude: 48.35590999999999,
        longitude: 11.131169999999994,
    },
    {
        latitude: 48.35604999999999,
        longitude: 11.131059999999994,
    },
    {
        latitude: 48.35811999999999,
        longitude: 11.129329999999994,
    },
    {
        latitude: 48.35869999999999,
        longitude: 11.128819999999994,
    },
    {
        latitude: 48.35942999999999,
        longitude: 11.128129999999993,
    },
    {
        latitude: 48.36013999999999,
        longitude: 11.127379999999993,
    },
    {
        latitude: 48.36047999999999,
        longitude: 11.126999999999994,
    },
    {
        latitude: 48.361009999999986,
        longitude: 11.126369999999994,
    },
    {
        latitude: 48.36152999999999,
        longitude: 11.125709999999994,
    },
    {
        latitude: 48.36202999999999,
        longitude: 11.125029999999995,
    },
    {
        latitude: 48.36248999999999,
        longitude: 11.124349999999996,
    },
    {
        latitude: 48.36276999999998,
        longitude: 11.123909999999997,
    },
    {
        latitude: 48.36333999999999,
        longitude: 11.122969999999997,
    },
    {
        latitude: 48.36360999999999,
        longitude: 11.122499999999997,
    },
    {
        latitude: 48.364029999999985,
        longitude: 11.121709999999997,
    },
    {
        latitude: 48.36470999999999,
        longitude: 11.120309999999996,
    },
    {
        latitude: 48.365129999999986,
        longitude: 11.119359999999997,
    },
    {
        latitude: 48.36551999999999,
        longitude: 11.118379999999997,
    },
    {
        latitude: 48.36584999999999,
        longitude: 11.117479999999997,
    },
    {
        latitude: 48.366289999999985,
        longitude: 11.116149999999998,
    },
    {
        latitude: 48.36660999999999,
        longitude: 11.115069999999998,
    },
    {
        latitude: 48.36678999999999,
        longitude: 11.114389999999998,
    },
    {
        latitude: 48.36718999999999,
        longitude: 11.112759999999998,
    },
    {
        latitude: 48.36768999999999,
        longitude: 11.110609999999998,
    },
    {
        latitude: 48.36808999999999,
        longitude: 11.108979999999997,
    },
    {
        latitude: 48.36829999999999,
        longitude: 11.108199999999997,
    },
    {
        latitude: 48.36850999999999,
        longitude: 11.107479999999997,
    },
    {
        latitude: 48.36872999999999,
        longitude: 11.106789999999997,
    },
    {
        latitude: 48.36908999999999,
        longitude: 11.105759999999997,
    },
    {
        latitude: 48.36932999999999,
        longitude: 11.105129999999997,
    },
    {
        latitude: 48.36966999999999,
        longitude: 11.104279999999997,
    },
    {
        latitude: 48.37003999999999,
        longitude: 11.103439999999997,
    },
    {
        latitude: 48.37017999999999,
        longitude: 11.103139999999998,
    },
    {
        latitude: 48.37073999999999,
        longitude: 11.102029999999997,
    },
    {
        latitude: 48.37141999999999,
        longitude: 11.100809999999997,
    },
    {
        latitude: 48.37197999999999,
        longitude: 11.099879999999997,
    },
    {
        latitude: 48.374019999999994,
        longitude: 11.096679999999997,
    },
    {
        latitude: 48.37459,
        longitude: 11.095769999999998,
    },
    {
        latitude: 48.375409999999995,
        longitude: 11.094479999999999,
    },
    {
        latitude: 48.375679999999996,
        longitude: 11.09405,
    },
    {
        latitude: 48.38061999999999,
        longitude: 11.086279999999999,
    },
    {
        latitude: 48.382769999999994,
        longitude: 11.083059999999998,
    },
    {
        latitude: 48.38513,
        longitude: 11.079619999999998,
    },
    {
        latitude: 48.387069999999994,
        longitude: 11.076749999999999,
    },
    {
        latitude: 48.38797999999999,
        longitude: 11.07542,
    },
    {
        latitude: 48.38826999999999,
        longitude: 11.07499,
    },
    {
        latitude: 48.390649999999994,
        longitude: 11.07146,
    },
    {
        latitude: 48.390879999999996,
        longitude: 11.071110000000001,
    },
    {
        latitude: 48.39167,
        longitude: 11.069830000000001,
    },
    {
        latitude: 48.392089999999996,
        longitude: 11.06914,
    },
    {
        latitude: 48.392709999999994,
        longitude: 11.068000000000001,
    },
    {
        latitude: 48.392849999999996,
        longitude: 11.06774,
    },
    {
        latitude: 48.39339,
        longitude: 11.066650000000001,
    },
    {
        latitude: 48.39353,
        longitude: 11.066320000000001,
    },
    {
        latitude: 48.39386,
        longitude: 11.065840000000001,
    },
    {
        latitude: 48.393989999999995,
        longitude: 11.065680000000002,
    },
    {
        latitude: 48.394099999999995,
        longitude: 11.065580000000002,
    },
    {
        latitude: 48.39422999999999,
        longitude: 11.065510000000003,
    },
    {
        latitude: 48.394299999999994,
        longitude: 11.065490000000004,
    },
    {
        latitude: 48.3944,
        longitude: 11.065480000000004,
    },
    {
        latitude: 48.39454,
        longitude: 11.065490000000004,
    },
    {
        latitude: 48.39467,
        longitude: 11.065540000000004,
    },
    {
        latitude: 48.39487,
        longitude: 11.065690000000004,
    },
    {
        latitude: 48.394909999999996,
        longitude: 11.065760000000003,
    },
    {
        latitude: 48.395379999999996,
        longitude: 11.066570000000002,
    },
    {
        latitude: 48.39592,
        longitude: 11.067510000000002,
    },
    {
        latitude: 48.39599,
        longitude: 11.067670000000001,
    },
    {
        latitude: 48.396029999999996,
        longitude: 11.067800000000002,
    },
    {
        latitude: 48.39608,
        longitude: 11.068040000000002,
    },
    {
        latitude: 48.39599,
        longitude: 11.068050000000001,
    },
    {
        latitude: 48.395889999999994,
        longitude: 11.06811,
    },
    {
        latitude: 48.395759999999996,
        longitude: 11.068040000000002,
    },
    {
        latitude: 48.39561,
        longitude: 11.067900000000002,
    },
    {
        latitude: 48.39548,
        longitude: 11.067830000000002,
    },
    {
        latitude: 48.39537,
        longitude: 11.067790000000002,
    },
    {
        latitude: 48.39527,
        longitude: 11.067770000000003,
    },
    {
        latitude: 48.39494,
        longitude: 11.067810000000003,
    },
    {
        latitude: 48.3948,
        longitude: 11.067800000000004,
    },
    {
        latitude: 48.39463,
        longitude: 11.067760000000003,
    },
    {
        latitude: 48.39447,
        longitude: 11.067670000000003,
    },
    {
        latitude: 48.39407,
        longitude: 11.067370000000004,
    },
    {
        latitude: 48.393589999999996,
        longitude: 11.066880000000005,
    },
    {
        latitude: 48.39339,
        longitude: 11.066650000000005,
    },
    {
        latitude: 48.39306,
        longitude: 11.066330000000004,
    },
    {
        latitude: 48.39295,
        longitude: 11.066210000000003,
    },
    {
        latitude: 48.39286,
        longitude: 11.066090000000003,
    },
    {
        latitude: 48.39272,
        longitude: 11.065900000000003,
    },
    {
        latitude: 48.392669999999995,
        longitude: 11.065810000000003,
    },
    {
        latitude: 48.39254999999999,
        longitude: 11.065520000000003,
    },
    {
        latitude: 48.39249999999999,
        longitude: 11.065230000000003,
    },
    {
        latitude: 48.39248999999999,
        longitude: 11.064950000000003,
    },
    {
        latitude: 48.39253999999999,
        longitude: 11.064610000000004,
    },
    {
        latitude: 48.39263999999999,
        longitude: 11.064180000000004,
    },
    {
        latitude: 48.393029999999996,
        longitude: 11.063370000000004,
    },
    {
        latitude: 48.39319,
        longitude: 11.063010000000004,
    },
    {
        latitude: 48.39364,
        longitude: 11.061870000000004,
    },
    {
        latitude: 48.39395,
        longitude: 11.060970000000005,
    },
    {
        latitude: 48.394189999999995,
        longitude: 11.060230000000004,
    },
    {
        latitude: 48.394479999999994,
        longitude: 11.059280000000005,
    },
    {
        latitude: 48.39489,
        longitude: 11.057770000000005,
    },
    {
        latitude: 48.394969999999994,
        longitude: 11.057430000000005,
    },
    {
        latitude: 48.39502999999999,
        longitude: 11.057190000000006,
    },
    {
        latitude: 48.39525999999999,
        longitude: 11.056250000000006,
    },
    {
        latitude: 48.39533999999999,
        longitude: 11.055850000000005,
    },
    {
        latitude: 48.39544999999999,
        longitude: 11.055360000000006,
    },
    {
        latitude: 48.39552999999999,
        longitude: 11.055010000000006,
    },
    {
        latitude: 48.39562999999999,
        longitude: 11.054530000000007,
    },
    {
        latitude: 48.39570999999999,
        longitude: 11.054140000000007,
    },
    {
        latitude: 48.39577999999999,
        longitude: 11.053790000000008,
    },
    {
        latitude: 48.39589999999999,
        longitude: 11.053070000000009,
    },
    {
        latitude: 48.39594999999999,
        longitude: 11.05259000000001,
    },
    {
        latitude: 48.39598999999999,
        longitude: 11.05221000000001,
    },
    {
        latitude: 48.39603999999999,
        longitude: 11.05151000000001,
    },
    {
        latitude: 48.39605999999999,
        longitude: 11.05099000000001,
    },
    {
        latitude: 48.39607999999999,
        longitude: 11.049930000000009,
    },
    {
        latitude: 48.39605999999999,
        longitude: 11.049140000000008,
    },
    {
        latitude: 48.39601999999999,
        longitude: 11.048250000000008,
    },
    {
        latitude: 48.395889999999994,
        longitude: 11.046850000000008,
    },
    {
        latitude: 48.395799999999994,
        longitude: 11.046200000000008,
    },
    {
        latitude: 48.395669999999996,
        longitude: 11.045570000000009,
    },
    {
        latitude: 48.39552,
        longitude: 11.045020000000008,
    },
    {
        latitude: 48.395329999999994,
        longitude: 11.044430000000007,
    },
    {
        latitude: 48.39505,
        longitude: 11.043690000000007,
    },
    {
        latitude: 48.39479,
        longitude: 11.043110000000008,
    },
    {
        latitude: 48.39445,
        longitude: 11.042230000000007,
    },
    {
        latitude: 48.39354,
        longitude: 11.040320000000007,
    },
    {
        latitude: 48.393100000000004,
        longitude: 11.039420000000007,
    },
    {
        latitude: 48.39186,
        longitude: 11.037120000000007,
    },
    {
        latitude: 48.39133,
        longitude: 11.036220000000007,
    },
    {
        latitude: 48.39081,
        longitude: 11.035390000000007,
    },
    {
        latitude: 48.39023,
        longitude: 11.034570000000008,
    },
    {
        latitude: 48.389590000000005,
        longitude: 11.033710000000008,
    },
    {
        latitude: 48.38881000000001,
        longitude: 11.032760000000009,
    },
    {
        latitude: 48.38862,
        longitude: 11.032560000000009,
    },
    {
        latitude: 48.38834000000001,
        longitude: 11.03226000000001,
    },
    {
        latitude: 48.388020000000004,
        longitude: 11.03193000000001,
    },
    {
        latitude: 48.387820000000005,
        longitude: 11.03171000000001,
    },
    {
        latitude: 48.38759,
        longitude: 11.03147000000001,
    },
    {
        latitude: 48.387350000000005,
        longitude: 11.031210000000009,
    },
    {
        latitude: 48.387080000000005,
        longitude: 11.030900000000008,
    },
    {
        latitude: 48.386320000000005,
        longitude: 11.030030000000007,
    },
    {
        latitude: 48.385110000000005,
        longitude: 11.028680000000007,
    },
    {
        latitude: 48.38414,
        longitude: 11.027640000000007,
    },
    {
        latitude: 48.383700000000005,
        longitude: 11.027110000000008,
    },
    {
        latitude: 48.383340000000004,
        longitude: 11.026570000000007,
    },
    {
        latitude: 48.38304,
        longitude: 11.026090000000007,
    },
    {
        latitude: 48.38274,
        longitude: 11.025490000000007,
    },
    {
        latitude: 48.382549999999995,
        longitude: 11.025030000000006,
    },
    {
        latitude: 48.382419999999996,
        longitude: 11.024650000000007,
    },
    {
        latitude: 48.38216,
        longitude: 11.023780000000006,
    },
    {
        latitude: 48.38207,
        longitude: 11.023390000000006,
    },
    {
        latitude: 48.3819,
        longitude: 11.022380000000005,
    },
    {
        latitude: 48.381820000000005,
        longitude: 11.021930000000005,
    },
    {
        latitude: 48.38158000000001,
        longitude: 11.020730000000004,
    },
    {
        latitude: 48.381350000000005,
        longitude: 11.020050000000005,
    },
    {
        latitude: 48.381150000000005,
        longitude: 11.019560000000006,
    },
    {
        latitude: 48.38105,
        longitude: 11.019340000000005,
    },
    {
        latitude: 48.38092,
        longitude: 11.019070000000005,
    },
    {
        latitude: 48.38053,
        longitude: 11.018330000000004,
    },
    {
        latitude: 48.37883,
        longitude: 11.015130000000005,
    },
    {
        latitude: 48.37873,
        longitude: 11.014950000000004,
    },
    {
        latitude: 48.377919999999996,
        longitude: 11.013440000000005,
    },
    {
        latitude: 48.377039999999994,
        longitude: 11.011840000000005,
    },
    {
        latitude: 48.37676,
        longitude: 11.011260000000005,
    },
    {
        latitude: 48.37656,
        longitude: 11.010760000000005,
    },
    {
        latitude: 48.37631,
        longitude: 11.010010000000005,
    },
    {
        latitude: 48.3762,
        longitude: 11.009580000000005,
    },
    {
        latitude: 48.37578,
        longitude: 11.007980000000005,
    },
    {
        latitude: 48.3757,
        longitude: 11.007680000000006,
    },
    {
        latitude: 48.37548,
        longitude: 11.006940000000005,
    },
    {
        latitude: 48.37529,
        longitude: 11.006290000000005,
    },
    {
        latitude: 48.375189999999996,
        longitude: 11.005940000000006,
    },
    {
        latitude: 48.375049999999995,
        longitude: 11.005470000000006,
    },
    {
        latitude: 48.37488,
        longitude: 11.004900000000006,
    },
    {
        latitude: 48.374669999999995,
        longitude: 11.004280000000007,
    },
    {
        latitude: 48.37452999999999,
        longitude: 11.003980000000007,
    },
    {
        latitude: 48.374399999999994,
        longitude: 11.003780000000008,
    },
    {
        latitude: 48.37432,
        longitude: 11.003680000000008,
    },
    {
        latitude: 48.37417,
        longitude: 11.003540000000008,
    },
    {
        latitude: 48.37406,
        longitude: 11.003460000000008,
    },
    {
        latitude: 48.37396,
        longitude: 11.003410000000008,
    },
    {
        latitude: 48.37374,
        longitude: 11.003360000000008,
    },
    {
        latitude: 48.37358,
        longitude: 11.003360000000008,
    },
    {
        latitude: 48.37327,
        longitude: 11.003420000000007,
    },
    {
        latitude: 48.373079999999995,
        longitude: 11.003480000000007,
    },
    {
        latitude: 48.372249999999994,
        longitude: 11.003800000000007,
    },
    {
        latitude: 48.37192999999999,
        longitude: 11.003880000000008,
    },
    {
        latitude: 48.37158999999999,
        longitude: 11.003870000000008,
    },
    {
        latitude: 48.37148999999999,
        longitude: 11.003850000000009,
    },
    {
        latitude: 48.371349999999985,
        longitude: 11.003800000000009,
    },
    {
        latitude: 48.371239999999986,
        longitude: 11.003750000000009,
    },
    {
        latitude: 48.37104999999998,
        longitude: 11.003610000000009,
    },
    {
        latitude: 48.37085999999998,
        longitude: 11.00340000000001,
    },
    {
        latitude: 48.37065999999998,
        longitude: 11.00308000000001,
    },
    {
        latitude: 48.37056999999998,
        longitude: 11.00289000000001,
    },
    {
        latitude: 48.37028999999998,
        longitude: 11.00214000000001,
    },
    {
        latitude: 48.37005999999998,
        longitude: 11.00144000000001,
    },
    {
        latitude: 48.36981999999998,
        longitude: 11.00076000000001,
    },
    {
        latitude: 48.369469999999986,
        longitude: 10.99987000000001,
    },
    {
        latitude: 48.369309999999984,
        longitude: 10.99947000000001,
    },
    {
        latitude: 48.36849999999998,
        longitude: 10.99754000000001,
    },
    {
        latitude: 48.36835999999998,
        longitude: 10.99721000000001,
    },
    {
        latitude: 48.36815999999998,
        longitude: 10.99679000000001,
    },
    {
        latitude: 48.36792999999998,
        longitude: 10.99641000000001,
    },
    {
        latitude: 48.36737999999998,
        longitude: 10.99569000000001,
    },
    {
        latitude: 48.36712999999998,
        longitude: 10.99532000000001,
    },
    {
        latitude: 48.36694999999998,
        longitude: 10.99500000000001,
    },
    {
        latitude: 48.36687999999998,
        longitude: 10.99485000000001,
    },
    {
        latitude: 48.36676999999998,
        longitude: 10.99459000000001,
    },
    {
        latitude: 48.36658999999998,
        longitude: 10.99410000000001,
    },
    {
        latitude: 48.36627999999998,
        longitude: 10.99324000000001,
    },
    {
        latitude: 48.36623999999998,
        longitude: 10.993140000000011,
    },
    {
        latitude: 48.36611999999998,
        longitude: 10.992790000000012,
    },
    {
        latitude: 48.36571999999998,
        longitude: 10.991680000000011,
    },
    {
        latitude: 48.36551999999998,
        longitude: 10.991170000000011,
    },
    {
        latitude: 48.365389999999984,
        longitude: 10.990920000000012,
    },
    {
        latitude: 48.36526999999998,
        longitude: 10.990740000000011,
    },
    {
        latitude: 48.36511999999998,
        longitude: 10.990550000000011,
    },
    {
        latitude: 48.36484999999998,
        longitude: 10.990230000000011,
    },
    {
        latitude: 48.36463999999998,
        longitude: 10.989980000000012,
    },
    {
        latitude: 48.36429999999998,
        longitude: 10.98958000000001,
    },
    {
        latitude: 48.36351999999998,
        longitude: 10.98864000000001,
    },
    {
        latitude: 48.36331999999998,
        longitude: 10.988430000000012,
    },
    {
        latitude: 48.36313999999998,
        longitude: 10.988270000000012,
    },
    {
        latitude: 48.36295999999998,
        longitude: 10.988140000000012,
    },
    {
        latitude: 48.36264999999998,
        longitude: 10.987980000000013,
    },
    {
        latitude: 48.362479999999984,
        longitude: 10.987900000000012,
    },
    {
        latitude: 48.36219999999999,
        longitude: 10.987780000000011,
    },
    {
        latitude: 48.36174999999999,
        longitude: 10.987630000000012,
    },
    {
        latitude: 48.36154999999999,
        longitude: 10.987560000000013,
    },
    {
        latitude: 48.36146999999999,
        longitude: 10.987540000000013,
    },
    {
        latitude: 48.36139999999999,
        longitude: 10.987510000000013,
    },
    {
        latitude: 48.36122999999999,
        longitude: 10.987430000000012,
    },
    {
        latitude: 48.36119999999999,
        longitude: 10.987410000000013,
    },
    {
        latitude: 48.36116999999999,
        longitude: 10.987400000000013,
    },
    {
        latitude: 48.361099999999986,
        longitude: 10.987360000000013,
    },
    {
        latitude: 48.360939999999985,
        longitude: 10.987270000000013,
    },
    {
        latitude: 48.360719999999986,
        longitude: 10.987100000000012,
    },
    {
        latitude: 48.360539999999986,
        longitude: 10.987230000000013,
    },
    {
        latitude: 48.36041999999998,
        longitude: 10.987280000000013,
    },
    {
        latitude: 48.36027999999998,
        longitude: 10.987290000000012,
    },
    {
        latitude: 48.359999999999985,
        longitude: 10.987210000000012,
    },
    {
        latitude: 48.35982999999999,
        longitude: 10.987090000000011,
    },
    {
        latitude: 48.359619999999985,
        longitude: 10.986940000000011,
    },
    {
        latitude: 48.359099999999984,
        longitude: 10.98649000000001,
    },
    {
        latitude: 48.358769999999986,
        longitude: 10.98618000000001,
    },
    {
        latitude: 48.358539999999984,
        longitude: 10.98594000000001,
    },
    {
        latitude: 48.35836999999999,
        longitude: 10.98569000000001,
    },
    {
        latitude: 48.35797999999998,
        longitude: 10.984870000000011,
    },
    {
        latitude: 48.35787999999998,
        longitude: 10.984670000000012,
    },
    {
        latitude: 48.35779999999998,
        longitude: 10.984560000000013,
    },
    {
        latitude: 48.357719999999986,
        longitude: 10.984470000000012,
    },
    {
        latitude: 48.35758999999999,
        longitude: 10.984370000000013,
    },
    {
        latitude: 48.35738999999999,
        longitude: 10.984250000000012,
    },
    {
        latitude: 48.35720999999999,
        longitude: 10.984170000000011,
    },
    {
        latitude: 48.35709999999999,
        longitude: 10.984150000000012,
    },
    {
        latitude: 48.35666999999999,
        longitude: 10.984190000000012,
    },
] as const;
